{
  "translation": {
    "ADD_COMPANY.CODE.LABEL": "Company Code",
    "ADD_COMPANY.COUNTRY.LABEL": "Country",
    "ADD_COMPANY.COUNTRY.PLACEHOLDER": "Select a country",
    "ADD_COMPANY.CURRENCY.LABEL": "Currency",
    "ADD_COMPANY.CURRENCY.PLACEHOLDER": "Select a currency",
    "ADD_COMPANY.LANGUAGE.LABEL": "Language",
    "ADD_COMPANY.LOGO.LABEL": "Select Logo",
    "ADD_COMPANY.MEASUREMENT_TYPE.LABEL": "Measurement Type",
    "ADD_COMPANY.MEASUREMENT_TYPE.PLACEHOLDER": "Select a measurement type",
    "ADD_COMPANY.NAME.LABEL": "Name",
    "ADD_COMPANY.PARTNER.LABEL": "Partner",
    "ADD_COMPANY.PARTNER.PLACEHOLDER": "Select a partner",
    "ADD_COMPANY.RESPONSE.SUCCESS": "The Company has been successfully created",
    "ADD_COMPANY.SUBMIT": "Add New Company",
    "ADD_COMPANY.TITLE": "Add New Company",
    "ADD_COMPANY.VALIDATION.CODE": "Company Code is required",
    "ADD_COMPANY.VALIDATION.COUNTRY": "Country is required",
    "ADD_COMPANY.VALIDATION.CURRENCY": "Currency is required",
    "ADD_COMPANY.VALIDATION.IMAGE": "Company logo is required",
    "ADD_COMPANY.VALIDATION.LANGUAGE": "Language is required",
    "ADD_COMPANY.VALIDATION.MEASUREMENT_TYPE": "Measurement type is required",
    "ADD_COMPANY.VALIDATION.NAME": "Name is required",
    "ADD_COMPANY.VALIDATION.PARTNER": "Partner is required",
    "ADD_FLOW_DATA.BTN.FLOW_DATA": "Add Flow Data",
    "ADD_FLOW_DATA.BTN.SUBMIT": "Submit",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.LABEL": "Date and Time of Flow Data",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.PLACEHOLDER": "Click here to select date and time",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.LABEL": "Value",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.PLACEHOLDER": "Flow Data Value",
    "ADD_FLOW_DATA.MODAL.ERROR.DESC": "Please try again the flow data has not been updated",
    "ADD_FLOW_DATA.MODAL.ERROR.TITLE": "Try again!",
    "ADD_FLOW_DATA.MODAL.SUCCESS.DESC": "The flow data has been updated",
    "ADD_FLOW_DATA.MODAL.SUCCESS.TITLE": "Awesome!",
    "ADD_PARTNER.ADDRESS.LABEL": "Address",
    "ADD_PARTNER.CODE.LABEL": "Code",
    "ADD_PARTNER.COUNTRY.LABEL": "Country",
    "ADD_PARTNER.COUNTRY.PLACEHOLDER": "Select a Country",
    "ADD_PARTNER.CURRENCY.LABEL": "Currency",
    "ADD_PARTNER.CURRENCY.PLACEHOLDER": "Select a Currency",
    "ADD_PARTNER.LOGO.LABEL": "Select Logo",
    "ADD_PARTNER.NAME.LABEL": "Name",
    "ADD_PARTNER.RESPONSE.SUCCESS": "The Partner has been successfully created",
    "ADD_PARTNER.SUBMIT": "Add New Partner",
    "ADD_PARTNER.TITLE": "Add New Partner",
    "ADD_PARTNER.VALIDATION.ADDRESS": "Address is required",
    "ADD_PARTNER.VALIDATION.CODE": "Code is required",
    "ADD_PARTNER.VALIDATION.COUNTRY": "Country is required",
    "ADD_PARTNER.VALIDATION.CURRENCY": "Currency is required",
    "ADD_PARTNER.VALIDATION.IMAGE": "Partner image is required",
    "ADD_PARTNER.VALIDATION.NAME": "Name is required",
    "ADD_PROJECT.COMPANY.LABEL": "Company",
    "ADD_PROJECT.COMPANY.PLACEHOLDER": "Select a company",
    "ADD_PROJECT.COST_PER_KM.LABEL": "Cost per KM($)",
    "ADD_PROJECT.CURRENCY.LABEL": "Currency",
    "ADD_PROJECT.CURRENCY.PLACEHOLDER": "Select a currency",
    "ADD_PROJECT.DMAS.LABEL": "DMAs",
    "ADD_PROJECT.DMAS.NO_MATCHING": "No Matching DMAs",
    "ADD_PROJECT.DMAS.PLACEHOLDER": "Select DMAs",
    "ADD_PROJECT.END_DATE.LABEL": "End Date",
    "ADD_PROJECT.MEASUREMENT_TYPE.LABEL": "Measurement Type",
    "ADD_PROJECT.MEASUREMENT_TYPE.PLACEHOLDER": "Select a measurement type",
    "ADD_PROJECT.NAME.LABEL": "Add New Project",
    "ADD_PROJECT.RESPONSE.SUCCESS": "The Project has been successfully created",
    "ADD_PROJECT.START_DATE.LABEL": "Start Date",
    "ADD_PROJECT.SUBMIT": "Create New Project",
    "ADD_PROJECT.TITLE": "Add New Project",
    "ADD_PROJECT.VALIDATION.COMPANY": "Company is required",
    "ADD_PROJECT.VALIDATION.COST_PER_KM": "Cost per KM is required",
    "ADD_PROJECT.VALIDATION.CURRENCY": "Currency is required",
    "ADD_PROJECT.VALIDATION.END_DATE": "End date is required",
    "ADD_PROJECT.VALIDATION.MEASUREMENT_TYPE": "Measurement type is required",
    "ADD_PROJECT.VALIDATION.NAME": "Name is required",
    "ADD_PROJECT.VALIDATION.START_DATE": "Start date is required",
    "ADD_USER.MODAL.BTN.CLOSE": "Close Modal",
    "ADD_USER.RESPONSE.SUCCESS": "The user has been successfully created",
    "ADD_USER.SUBMIT": "Add New User",
    "ADD_USER.TITLE": "Add New User",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_ID": "Asset ID",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_TYPE": "Standardized Asset Type",
    "ASSET_TOOLTIP.ERROR": "Could not retrieve asset information",
    "ASSET_TOOLTIP.NO_DATA": "No session information available",
    "ASSET_TOOLTIP.TABLE.HEADER.1": "Session ID",
    "ASSET_TOOLTIP.TABLE.HEADER.2": "Bug ID",
    "ASSET_TOOLTIP.TABLE.HEADER.3": "Timestamp",
    "ASSET_TOOLTIP.TABLE.HEADER.4": "Outcome",
    "ASSET_TOOLTIP.TITLE.ASSET": "Asset Information",
    "ASSET_TOOLTIP.TITLE.SESSION": "Session Information",
    "BREADCRUMB.FILTERS.COMPANY": "Company",
    "BREADCRUMB.FILTERS.DATE_FROM": "Date from",
    "BREADCRUMB.FILTERS.DATE_TO": "Date to",
    "BREADCRUMB.FILTERS.DATEFROM": "Date from",
    "BREADCRUMB.FILTERS.DATETO": "Date to",
    "BREADCRUMB.FILTERS.DAY": "Day",
    "BREADCRUMB.FILTERS.ENGINEER": "Engineer",
    "BREADCRUMB.FILTERS.PARTNER": "Partner",
    "BREADCRUMB.FILTERS.PROJECT": "Project",
    "BROWSE_HOME_PAGE.TITLE": "Select a data type to begin browsing.",
    "BROWSE_VIEW.BACK_TO_LIST": "Back to list",
    "BROWSE_VIEW.MEDIA_SECTION.EMPTY_MSG": "No media for this waypoint",
    "BROWSE_VIEW.MEDIA_SECTION.LABEL": "Media",
    "BROWSE_VIEW.RELAY.ADDRESS": "Address",
    "BROWSE_VIEW.RELAY.DEPLOYED_BY": "Deployed By",
    "BROWSE_VIEW.RELAY.LAST_CONTACT": "Last Contact",
    "BROWSE_VIEW.RELAY.LAST_UPLOADED": "Last Uploaded",
    "BROWSE_VIEW.RELAY.NO_NAME_PLACEHOLDER": "Relay",
    "BROWSE_VIEW.RELAY.SESSION": "Session",
    "BROWSE_VIEW.RELAY.UPDATED": "Updated",
    "BROWSE_VIEW.RELAY.W3W": "What 3 Words",
    "BROWSE_VIEW.SENSOR.BATTERY_VOLTAGE": "Battery Voltage",
    "BROWSE_VIEW.SENSOR.COLLECTED_BY": "Collected By",
    "BROWSE_VIEW.SENSOR.DEPLOYED_BY": "Deployed By",
    "BROWSE_VIEW.SENSOR.END_TIME": "End Time",
    "BROWSE_VIEW.SENSOR.FIRMWARE_VERSION": "Version",
    "BROWSE_VIEW.SENSOR.LAST_UPLOADED": "Last Uploaded",
    "BROWSE_VIEW.SENSOR.LATEST_SESSION": "Latest Session",
    "BROWSE_VIEW.SENSOR.SESSION": "Session",
    "BROWSE_VIEW.SENSOR.SESSION_TYPE": "Session Type",
    "BROWSE_VIEW.SENSOR.START_TIME": "Start Time",
    "BROWSE_VIEW.SESSION.LAST_UPLOADED": "Last Uploaded",
    "BROWSE_VIEW.WAYPOINT.ADD_JOB": "Add job",
    "BROWSE_VIEW.WAYPOINT.ADDRESS": "Address",
    "BROWSE_VIEW.WAYPOINT.CREATED": "Created",
    "BROWSE_VIEW.WAYPOINT.DIAMETER": "Diameter",
    "BROWSE_VIEW.WAYPOINT.ENG_NOTES": "Engineering notes",
    "BROWSE_VIEW.WAYPOINT.ENGINEER": "Assigned Engineer",
    "BROWSE_VIEW.WAYPOINT.ENV_NOTES": "Environmental notes",
    "BROWSE_VIEW.WAYPOINT.MATERIAL": "Pipe Material",
    "BROWSE_VIEW.WAYPOINT.MERGE_WP": "Merge Waypoint",
    "BROWSE_VIEW.WAYPOINT.NO_NAME_PLACEHOLDER": "Unnamed Waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.ACTIVITIES": "Activities",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES": "Consumption Profiles",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES_EMTPY": "No consumption profiles for this waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS": "Correlations",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS_EMPTY": "No correlations for this waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY": "History",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY_EMPTY": "No history for this waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS": "Jobs",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS_EMPTY": "No jobs for this waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES": "Notes",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES_EMPTY": "No notes for this waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS": "Sessions",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS_EMPTY": "No sessions for this waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS": "Soundings",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS_EMPTY": "No soundings for this waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS": "Top Soundings",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS_EMPTY": "No top soundings for this waypoint",
    "BROWSE_VIEW.WAYPOINT.UPDATED": "Updated",
    "BROWSE_VIEW.WAYPOINT.W3W": "What 3 Words",
    "BROWSE.FILTERS.COLLECTED_BY": "Collected By",
    "BROWSE.FILTERS.COLLECTED_BY_PLACEHOLDER": "Select collected by user",
    "BROWSE.FILTERS.COMPANY": "Company",
    "BROWSE.FILTERS.COMPANY_NAME": "Company Name",
    "BROWSE.FILTERS.COMPANY_PLACEHOLDER": "Select companies",
    "BROWSE.FILTERS.DEPLOYED_BY": "Deployed By",
    "BROWSE.FILTERS.DEPLOYED_BY_PLACEHOLDER": "Select deployed by user",
    "BROWSE.FILTERS.DMA": "DMA",
    "BROWSE.FILTERS.DMA_KEY": "DMA Key",
    "BROWSE.FILTERS.DMA_PLACEHOLDER": "Select DMAs",
    "BROWSE.FILTERS.FILTER": "Filter",
    "BROWSE.FILTERS.FROM": "From",
    "BROWSE.FILTERS.ID": "ID",
    "BROWSE.FILTERS.JOB_TYPE": "Job type",
    "BROWSE.FILTERS.JOB_TYPE_PLACEHOLDER": "Select job type codes",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER": "Last scheduled engineer",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER_PLACEHOLDER": "Select last scheduled engineers",
    "BROWSE.FILTERS.LEAK_RESULTS": "Leak Results",
    "BROWSE.FILTERS.LEAK_RESULTS_PLACEHOLDER": "Select leak results",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION": "Most recent author of modification",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION_PLACEHOLDER": "Select last action users",
    "BROWSE.FILTERS.NAME": "Name",
    "BROWSE.FILTERS.OTHERS": "Others",
    "BROWSE.FILTERS.PARTNER": "Partner",
    "BROWSE.FILTERS.PARTNER_NAME": "Partner Name",
    "BROWSE.FILTERS.PARTNER_PLACEHOLDER": "Select partners",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE": "Predicted leak type",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE_PLACEHOLDER": "Select predicted leak types",
    "BROWSE.FILTERS.PREDICTED_SIZE": "Predicted size",
    "BROWSE.FILTERS.PREDICTED_SIZE_PLACEHOLDER": "Select predicted sizes",
    "BROWSE.FILTERS.PREDICTED_SIZE.CORRELATION": "Correlation",
    "BROWSE.FILTERS.PREDICTED_SIZE.ERROR": "Error",
    "BROWSE.FILTERS.PREDICTED_SIZE.LARGE": "Large",
    "BROWSE.FILTERS.PREDICTED_SIZE.MEDIUM": "Medium",
    "BROWSE.FILTERS.PREDICTED_SIZE.NA": "N/A",
    "BROWSE.FILTERS.PREDICTED_SIZE.NOT_ENOUGH_FILES": "Not enough files",
    "BROWSE.FILTERS.PREDICTED_SIZE.SMALL": "Small",
    "BROWSE.FILTERS.PROJECT": "Project",
    "BROWSE.FILTERS.PROJECT_PLACEHOLDER": "Select projects",
    "BROWSE.FILTERS.RELAY_CONNECTED": "Relay Connected",
    "BROWSE.FILTERS.RELAYS": "Relays",
    "BROWSE.FILTERS.SELECT_FIELD": "Select field",
    "BROWSE.FILTERS.SENSORS": "Sensors",
    "BROWSE.FILTERS.SESSION_STATUS.AWAITING_UPLOAD": "Awaiting Upload",
    "BROWSE.FILTERS.SESSION_STATUS.COMPLETED": "Completed",
    "BROWSE.FILTERS.SESSION_STATUS.DELETED": "Deleted",
    "BROWSE.FILTERS.SESSION_STATUS.IN_PROGRESS": "In Progress",
    "BROWSE.FILTERS.SESSION_TYPE.CONTINUOUS": "Continuous",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION": "Correlation",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_1_MIN_DELAY": "Correlation: 1 minute delay",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_12_MIN_DELAY": "Correlation: 12 minute delay",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_15_MIN_DELAY": "Correlation: 15 minute delay",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_5_MIN_DELAY": "Correlation: 5 minute delay",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_8_MIN_DELAY": "Correlation: 8 minute delay",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_CHILD": "Correlation Child",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_PARENT": "Correlation Parent",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_DAY": "FCC: 3 minute day",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_NIGHT": "FCC: 3 minute night",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_DAY": "FCC: 5 minute day",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_NIGHT": "FCC: 5 minute night",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_DAY": "FCC: 8 minute day",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_NIGHT": "FCC: 8 minute night",
    "BROWSE.FILTERS.SESSION_TYPE.FIVE_MINUTES": "5 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.ONE_HOUR": "1 hour",
    "BROWSE.FILTERS.SESSION_TYPE.OVERNIGHT": "Overnight",
    "BROWSE.FILTERS.SESSION_TYPE.RELAY": "Relay",
    "BROWSE.FILTERS.SESSION_TYPE.SYSTEM_MODE": "System Mode",
    "BROWSE.FILTERS.SESSION_TYPE.TEST": "Test",
    "BROWSE.FILTERS.SESSION_TYPE.THIRTY_MINUTES": "30 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.TWENTY_FOUR_HOURS": "24 hours",
    "BROWSE.FILTERS.SESSION_TYPE.TYPE": "Type",
    "BROWSE.FILTERS.SESSION_TYPES": "Session Types",
    "BROWSE.FILTERS.SESSION_TYPES_PLACEHOLDER": "Select session types",
    "BROWSE.FILTERS.SESSIONS": "Sessions",
    "BROWSE.FILTERS.SORTING": "Sorting",
    "BROWSE.FILTERS.STATUS": "Status",
    "BROWSE.FILTERS.STATUS_PLACEHOLDER": "Select statuses",
    "BROWSE.FILTERS.STATUS.MAINTENANCE_ALERT": "Maintenance Alert",
    "BROWSE.FILTERS.STATUS.OFFLINE": "Offline",
    "BROWSE.FILTERS.STATUS.OK": "OK",
    "BROWSE.FILTERS.STATUS.ONLINE": "Online",
    "BROWSE.FILTERS.STATUS.WARNING": "Warning",
    "BROWSE.FILTERS.TO": "To",
    "BROWSE.FILTERS.TYPES": "Types",
    "BROWSE.FILTERS.TYPES_PLACEHOLDER": "Select session types",
    "BROWSE.FILTERS.WAYPOINTS": "Waypoints",
    "BROWSE.LABELS.TYPE": "Type",
    "BROWSE.LAYOUT.LOADING_MAP": "Loading map",
    "BROWSE.LAYOUT.LOADING_MAP_DESCRIPTION": "Please wait while we initialize the interactive map...",
    "BROWSE.LAYOUT.LOADING_PREVIEW": "Loading preview",
    "BROWSE.LAYOUT.LOADING_PREVIEW_DESCRIPTION": "Please wait while we load your shared preview...",
    "BROWSE.LIST.BACK_TO_LIST": "Back to list",
    "BROWSE.LIST.JOBS_VIEW_ACTIVE": "Jobs View Active",
    "BROWSE.LIST.JOBS_VIEW_DESCRIPTION": "Job data is displayed on the map",
    "BROWSE.PANEL.COLLAPSE": "Collapse panel",
    "BROWSE.PANEL.EXPAND": "Expand panel",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_FOUND_LAST_7_DAYS": "Leaks found in the last 7 days",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_MARKED_UP_LAST_7_DAYS": "Leaks marked up in the last 7 days",
    "BROWSE.PREDEFINED_VIEWS.RELAY_NEEDS_MAINTENANCE": "Relay in need of maintenance",
    "BROWSE.PREDEFINED_VIEWS.RELAY_WARNINGS_LAST_7_DAYS": "Relay warnings in the last 7 days",
    "BROWSE.PREVIEW.CHANGE_WAYPOINT": "change waypoint",
    "BROWSE.SHARE.ADD_EMAIL": "Add email",
    "BROWSE.SHARE.ADD_MESSAGE": "Add a message",
    "BROWSE.SHARE.COPY_LINK": "Copy Link",
    "BROWSE.SHARE.ERROR.COPY_CLIPBOARD_FAILED": "Failed to copy link to clipboard",
    "BROWSE.SHARE.ERROR.GENERATE_LINK_FAILED": "Failed to generate share link",
    "BROWSE.SHARE.REMOVE_EMAIL": "Remove {{email}}",
    "BROWSE.SHARE.SEND": "Send",
    "BROWSE.SHARE.SUCCESS.EMAIL_SENT_AND_LINK_COPIED": "Email sent and link copied to clipboard!",
    "BROWSE.SHARE.SUCCESS.LINK_COPIED": "Link copied to clipboard!",
    "BROWSE.TABLE.COLUMNS.ADDRESS": "Address",
    "BROWSE.TABLE.COLUMNS.ASSET": "Asset",
    "BROWSE.TABLE.COLUMNS.BATTERY_VOLTAGE": "Battery Voltage",
    "BROWSE.TABLE.COLUMNS.COLLECTED_BY": "Collected By",
    "BROWSE.TABLE.COLUMNS.COMMENT": "Comment",
    "BROWSE.TABLE.COLUMNS.COMPANY": "Company",
    "BROWSE.TABLE.COLUMNS.COMPANY_NAME": "Company Name",
    "BROWSE.TABLE.COLUMNS.CREATED_AT": "Created At",
    "BROWSE.TABLE.COLUMNS.CREATED_DATE": "Created Date",
    "BROWSE.TABLE.COLUMNS.DEPLOYED_BY": "Deployed By",
    "BROWSE.TABLE.COLUMNS.DMA": "DMA",
    "BROWSE.TABLE.COLUMNS.END_DATE": "End Date",
    "BROWSE.TABLE.COLUMNS.END_TIME": "End Time",
    "BROWSE.TABLE.COLUMNS.ENVIRONMENTAL_NOTES": "Environmental Notes",
    "BROWSE.TABLE.COLUMNS.EST_SIZE_ENG": "Est. Size (Eng)",
    "BROWSE.TABLE.COLUMNS.EXPECTED_FINISH": "Expected Finish",
    "BROWSE.TABLE.COLUMNS.FIRMWARE": "Firmware",
    "BROWSE.TABLE.COLUMNS.FLOW_REDUCTION": "Flow Reduction",
    "BROWSE.TABLE.COLUMNS.ID": "ID",
    "BROWSE.TABLE.COLUMNS.JOB_COUNT": "Job Count",
    "BROWSE.TABLE.COLUMNS.JOB_TYPE_CODE": "Job Type Code",
    "BROWSE.TABLE.COLUMNS.JOBS": "Jobs",
    "BROWSE.TABLE.COLUMNS.LAST_ACTION_BY": "Last Action By",
    "BROWSE.TABLE.COLUMNS.LAST_CONTACT": "Last Contact",
    "BROWSE.TABLE.COLUMNS.LAST_SCHEDULED_ENGINEER": "Last Scheduled Engineer",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATE": "Last Update",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATED": "Last Updated",
    "BROWSE.TABLE.COLUMNS.LATITUDE": "Latitude",
    "BROWSE.TABLE.COLUMNS.LEAK_RESULT": "Leak Result",
    "BROWSE.TABLE.COLUMNS.LEAK_SIZE": "Leak Size",
    "BROWSE.TABLE.COLUMNS.LONGITUDE": "Longitude",
    "BROWSE.TABLE.COLUMNS.MAC_ADDRESS": "MAC Address",
    "BROWSE.TABLE.COLUMNS.NAME": "Name",
    "BROWSE.TABLE.COLUMNS.PARTNER": "Partner",
    "BROWSE.TABLE.COLUMNS.PARTNER_NAME": "Partner Name",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER": "Pipe Diameter",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER_UNITS": "Pipe Diameter Units",
    "BROWSE.TABLE.COLUMNS.PIPE_MATERIAL": "Pipe Material",
    "BROWSE.TABLE.COLUMNS.PREDICTED_LEAK_TYPE": "Predicted Leak Type",
    "BROWSE.TABLE.COLUMNS.PREDICTED_SIZE": "Predicted Size",
    "BROWSE.TABLE.COLUMNS.PROJECT": "Project",
    "BROWSE.TABLE.COLUMNS.RELAY_CONNECTED": "Relay Connected",
    "BROWSE.TABLE.COLUMNS.RELAY_ID": "Relay ID",
    "BROWSE.TABLE.COLUMNS.RELAY_NAME": "Relay Name",
    "BROWSE.TABLE.COLUMNS.SENSOR_ID": "Sensor ID",
    "BROWSE.TABLE.COLUMNS.SENSOR_MAC": "Sensor MAC",
    "BROWSE.TABLE.COLUMNS.SENSOR_NAME": "Sensor Name",
    "BROWSE.TABLE.COLUMNS.SESSION": "Session",
    "BROWSE.TABLE.COLUMNS.SESSION_COUNT": "Session Count",
    "BROWSE.TABLE.COLUMNS.SESSION_ID": "Session ID",
    "BROWSE.TABLE.COLUMNS.SESSION_TYPE": "Session Type",
    "BROWSE.TABLE.COLUMNS.SESSIONS": "Sessions",
    "BROWSE.TABLE.COLUMNS.SIZE": "Size",
    "BROWSE.TABLE.COLUMNS.START_DATE": "Start Date",
    "BROWSE.TABLE.COLUMNS.START_TIME": "Start Time",
    "BROWSE.TABLE.COLUMNS.STATUS": "Status",
    "BROWSE.TABLE.COLUMNS.SURFACE_TYPE": "Surface Type",
    "BROWSE.TABLE.COLUMNS.UPDATE_DATE": "Update Date",
    "BROWSE.TABLE.COLUMNS.WAYPOINT_NAME": "Waypoint Name",
    "BROWSE.TABLE.COLUMNS.WHAT3WORDS": "What3Words",
    "BROWSE.TABLE.ID_PREFIX": "ID:",
    "BROWSE.TABLE.SORT_BY": "Sort by {{field}}",
    "BROWSE.TABS.RELAYS": "Relays",
    "BROWSE.TABS.SENSORS": "Sensors",
    "BROWSE.TABS.SESSIONS": "Sessions",
    "BROWSE.TABS.WAYPOINTS": "Waypoints",
    "BROWSE.VIEWS.CREATED_SUCCESS": "Custom view created successfully",
    "BROWSE.VIEWS.DELETE_CONFIRM": "Delete saved view?",
    "BROWSE.VIEWS.DELETE_DESCRIPTION": "This will permanently delete \"{{name}}\".",
    "BROWSE.VIEWS.EMPTY": "No saved views yet",
    "BROWSE.VIEWS.LOAD_ERROR": "Failed to load views",
    "BROWSE.VIEWS.LOADING": "Loading views...",
    "BROWSE.VIEWS.POPOVER_DESCRIPTION": "You can save your go-to filters and access them with one click from here",
    "BROWSE.VIEWS.SAVE_BUTTON": "Save View",
    "BROWSE.VIEWS.SAVE_DESCRIPTION": "Give your custom view a name to save your current filters.",
    "BROWSE.VIEWS.SAVE_TITLE": "Save Custom View",
    "BROWSE.VIEWS.VIEW_NAME_LABEL": "View Name",
    "BROWSE.VIEWS.VIEW_NAME_PLACEHOLDER": "Enter view name",
    "BROWSE.VIEWS.YOUR_SAVED_VIEWS": "Your saved views",
    "BROWSE.VIEWS.YOUR_VIEWS_SHORT": "Your views",
    "CHANGE_LOG.ACTIONS.CREATE_BRANCH": "Create Project",
    "CHANGE_LOG.ACTIONS.CREATE_COMPANY": "Create company",
    "CHANGE_LOG.ACTIONS.CREATE_USER": "Create user invitation",
    "CHANGE_LOG.ACTIONS.DELETE_BRANCH": "Delete Project",
    "CHANGE_LOG.ACTIONS.DELETE_COMPANY": "Delete company",
    "CHANGE_LOG.ACTIONS.DELETE_USER": "Delete user",
    "CHANGE_LOG.ACTIONS.EDIT_COMPANY": "Edit Company",
    "CHANGE_LOG.ACTIONS.FORGOT_PASSWORD": "Send email with recovery link",
    "CHANGE_LOG.ACTIONS.GET_COMPANY": "Get company",
    "CHANGE_LOG.ACTIONS.LOGIN": "Login",
    "CHANGE_LOG.ACTIONS.SET_PASSWORD": "Set profile password",
    "CHANGE_LOG.ACTIONS.TOKEN_DECODE": "Decode email token",
    "CHANGE_LOG.ACTIONS.UPDATE_BRANCH": "Project was updated",
    "CHANGE_LOG.ACTIONS.UPDATE_USER": "User profile was updated",
    "CHANGE_LOG.FILTERS.ACTION.LABEL": "Action",
    "CHANGE_LOG.FILTERS.ACTION.PLACEHOLDER": "Select an action",
    "CHANGE_LOG.FILTERS.BRANCH.LABEL": "Project",
    "CHANGE_LOG.FILTERS.BRANCH.PLACEHOLDER": "Select a Project",
    "CHANGE_LOG.FILTERS.CLEAR": "Discard",
    "CHANGE_LOG.FILTERS.COMPANY.LABEL": "Company",
    "CHANGE_LOG.FILTERS.COMPANY.PLACEHOLDER": "Select a company",
    "CHANGE_LOG.FILTERS.DATE.LABEL": "Date",
    "CHANGE_LOG.FILTERS.DATE.PLACEHOLDER": "Select a date",
    "CHANGE_LOG.FILTERS.EMAIL.LABEL": "Email",
    "CHANGE_LOG.FILTERS.EMAIL.PLACEHOLDER": "Enter an email",
    "CHANGE_LOG.FILTERS.ERASE": "Clear",
    "CHANGE_LOG.FILTERS.STATUS.LABEL": "Status",
    "CHANGE_LOG.FILTERS.STATUS.PLACEHOLDER": "Select a status",
    "CHANGE_LOG.FILTERS.SUBMIT": "Filter",
    "CHANGE_LOG.FILTERS.TITLE": "Filters",
    "CHANGE_LOG.STATUSES.FAILURE": "Failure",
    "CHANGE_LOG.STATUSES.SUCCESS": "Success",
    "CHANGE_LOG.TABLE.ACTION": "Action",
    "CHANGE_LOG.TABLE.BRANCH": "Project",
    "CHANGE_LOG.TABLE.COMPANY": "Company",
    "CHANGE_LOG.TABLE.DATE": "Date",
    "CHANGE_LOG.TABLE.EMAIL": "Email",
    "CHANGE_LOG.TABLE.NAME": "Name",
    "CHANGE_LOG.TABLE.NUMBER": "№",
    "CHANGE_LOG.TABLE.ROLE": "Role",
    "CHANGE_LOG.TABLE.STATUS": "Status",
    "CHANGE_LOG.TABLE.TIME": "Time",
    "CHANGE_LOG.TITLE.NO_LOGS": "There are no logs",
    "CHANGE_LOG.TITLE.TOTAL_COUNT": "Total Logs:",
    "CHATBOT.DEFAULT_ASSISTANT_MSG": "How can I help you?",
    "CHATBOT.INPUT.PLACEHOLDER": "Write a message",
    "CHATBOT.OFFLINE_MSG": "askFIDO is currently unavailable. Please try again later.",
    "CHATBOT.RATING.RESPONSE": "Thanks for the feedback",
    "CHATBOT.SUBHEADING": "Online",
    "CHATBOT.SUBHEADING_ERROR": "Offline",
    "CHATBOT.YOU": "You",
    "COMMON.ACTION.CANCEL": "Cancel",
    "COMMON.ACTION.CLEAR": "Clear",
    "COMMON.ACTION.CLEAR_SEARCH": "Clear search",
    "COMMON.ACTION.CLOSE": "Close",
    "COMMON.ACTION.COPY_COORDINATES": "Copy coordinates",
    "COMMON.ACTION.COPY_COORDINATES_TO_CLIPBOARD": "Copy coordinates to clipboard",
    "COMMON.ACTION.DELETE": "Delete",
    "COMMON.ACTION.LOAD_MORE": "Load More",
    "COMMON.ACTION.RESET": "Reset",
    "COMMON.ACTION.SAVING": "Saving...",
    "COMMON.ACTION.SEARCH": "Search",
    "COMMON.ACTION.SHARE": "Share",
    "COMMON.BOOLEAN.NO": "No",
    "COMMON.BOOLEAN.YES": "Yes",
    "COMMON.BUTTON.EDIT": "edit",
    "COMMON.BUTTON.OPEN": "open",
    "COMMON.BUTTON.SHARE": "share",
    "COMMON.DATE.PLACEHOLDER.DDMMYYYY": "dd/mm/yyyy",
    "COMMON.EMPTY.ADJUST_FILTERS_OR_SEARCH": "Try adjusting your filters or search criteria",
    "COMMON.EMPTY.ADJUST_SEARCH_TERMS": "Try adjusting your search terms or check for typos",
    "COMMON.EMPTY.NO_DATA": "No data.",
    "COMMON.EMPTY.NO_RESULTS_FOUND": "No results found",
    "COMMON.ERROR.FAILED_TO_LOAD_DATA": "Failed to load data",
    "COMMON.ERROR.GENERIC_TRY_AGAIN_LATER": "An error occurred while fetching the data. Please try again later.",
    "COMMON.ERROR.SUGGESTIONS_FETCH": "An error occurred while fetching the suggestions. Please try again later.",
    "COMMON.FILTERS.APPLY_FILTERS": "Apply Filters",
    "COMMON.FILTERS.EMAILS_PLACEHOLDER": "Filter emails...",
    "COMMON.FILTERS.SAVE_FILTERS": "Save Filters",
    "COMMON.FILTERS.TOGGLE_FILTERS": "toggle filters",
    "COMMON.FORM.PLACEHOLDER.ZERO": "0",
    "COMMON.LOADING.GENERIC": "Loading...",
    "COMMON.LOADING.SUGGESTIONS": "Loading suggestions...",
    "COMMON.MEDIA.PAUSE_VIDEO": "Pause video",
    "COMMON.MEDIA.PLAY_AUDIO": "Play audio",
    "COMMON.MEDIA.PLAY_VIDEO": "Play video",
    "COMMON.MEDIA.UPLOAD_ALT": "Uploaded media",
    "COMMON.MEDIA.VIDEO_LOAD_ERROR": "An error occurred while loading the video. Please try again later.",
    "COMMON.PAGINATION.NEXT_PAGE": "Go to next page",
    "COMMON.PAGINATION.OF": "of",
    "COMMON.PAGINATION.PAGE_TITLE": "Page {{page}}",
    "COMMON.PAGINATION.PREVIOUS_PAGE": "Go to previous page",
    "COMMON.PAGINATION.ROWS_PER_PAGE": "Rows per page",
    "COMMON.SEARCH.RESULTS": "Results",
    "COMMON.SEARCH.SUGGESTIONS": "Suggestions",
    "COMMON.SEARCH.WAITING_FOR_TYPING": "Waiting for you to finish typing...",
    "COMMON.SORT.ASC": "Ascending",
    "COMMON.SORT.DESC": "Descending",
    "COMMON.TABLE.COLUMNS_SETTINGS": "Columns Settings",
    "COMMON.TABLE.CUSTOMIZE_TABLE": "Customize Table",
    "COMMON.TABLE.CUSTOMIZE_TABLE_DESCRIPTION": "Reorder, pin, and toggle column visibility",
    "COMMON.TABLE.DRAG_TO_PIN": "Drag columns here to pin them",
    "COMMON.TABLE.DRAG_TO_REORDER": "Drag to reorder",
    "COMMON.TABLE.DRAG_TO_UNPIN": "Drag columns here to unpin them",
    "COMMON.TABLE.MANAGE_COLUMNS": "Manage Columns",
    "COMMON.TABLE.MAX_PINNED_COLUMNS_REACHED": "Maximum pinned columns reached",
    "COMMON.TABLE.OTHER_COLUMNS": "Other Columns",
    "COMMON.TABLE.PIN_COLUMN": "Pin column",
    "COMMON.TABLE.PINNED_COLUMNS": "Pinned Columns",
    "COMMON.TABLE.PINNED_COLUMNS_COUNT": "Pinned Columns ({{current}}/{{max}})",
    "COMMON.TABLE.UNPIN_COLUMN": "Unpin column",
    "COMMON.UPLOAD.CHOOSE_FILE": "Choose file",
    "COMMON.VALIDATION.INVALID_EMAIL": "Invalid email address",
    "COMMON.VIEW.CLASSIC_VIEW": "Classic view",
    "COMMON.VIEW.LIST_VIEW": "List view",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.COMPANIES": "Companies",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.DEFAULT_TITLE": "Select a partner or company",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.PARTNERS": "Partners",
    "COMPANIES_PAGE.ADD_COMPANY.BUTTON": "New Company",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.LABEL": "Company Address",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.PLACEHOLDER": "Enter Address",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.LABEL": "Company Name",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.PLACEHOLDER": "Enter Name",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.SUBMIT": "Add",
    "COMPANIES_PAGE.ADD_COMPANY.TITLE": "Add New Company",
    "COMPANIES_PAGE.CRUMB": "Companies",
    "COMPANIES_PAGE.DELETE_COMPANY.TITLE": "Are you sure you want to delete this Company?",
    "COMPANIES_PAGE.SUBTITLE": "Some other Important information goes here",
    "COMPANIES_PAGE.TABLE.ACTIONS": "Actions",
    "COMPANIES_PAGE.TABLE.ADDRESS": "Address",
    "COMPANIES_PAGE.TABLE.BRANCHES": "Projects",
    "COMPANIES_PAGE.TABLE.ID": "ID",
    "COMPANIES_PAGE.TABLE.INDEX": "№",
    "COMPANIES_PAGE.TABLE.NAME": "Name",
    "COMPANIES_PAGE.TABLE.REPORTS": "Total Custom Reports",
    "COMPANIES_PAGE.TABLE.USERS": "Total Users",
    "COMPANIES_PAGE.TITLE.NO_COMPANIES": "There are no companies",
    "COMPANIES_PAGE.TITLE.TOTAL_COUNT": "Total Companies:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ALLOCATE_LE": "Allocate LE",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_ERROR": "Error, please try again",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_SUCCESS": "Success, waypoints have been allocated",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ASSIGN_WAYPOINTS": "Assign Selected Waypoints to Leak Engineer",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CHANGE": "Change",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CLOSE": "Close",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.NO_WAYPOINTS": "No waypoints selected",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.OPTION_ENGINEER": "Engineer:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.REMOVE": "remove",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SEARCH.PLACEHOLDER": "Search for engineer",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SELECTING_ERROR": "Please select an engineer and waypoints",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SUBMIT_BTN": "Assign waypoints",
    "COMPONENTS.COMPANY_SELECT.CHOOSE_COMPANY": "Choose a company/partner",
    "COMPONENTS.COMPANY_SELECT.COMPANY": "Project",
    "COMPONENTS.COMPANY_SELECT.ERROR": "Oops! Something went wrong. Please refresh the page and try again.",
    "COMPONENTS.COMPANY_SELECT.FORM.SEARCH.PLACEHOLDER": "Search for Company, Partner or Project",
    "COMPONENTS.COMPANY_SELECT.FORM.SELECT.PLACEHOLDER": "Select data type",
    "COMPONENTS.COMPANY_SELECT.NO_DATA": "There is no projects available",
    "COMPONENTS.COMPANY_SELECT.NO_RESULTS": "No results found",
    "COMPONENTS.COMPANY_SELECT.PARTNER": "Company/Partner",
    "COMPONENTS.COMPANY_SELECT.VIEW": "View",
    "COMPONENTS.DATE_VIEWER.END_DATE": "End Date",
    "COMPONENTS.DATE_VIEWER.START_DATE": "Start Date",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.COMPANIES": "Companies",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.ENGINEERS": "Engineers",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PARTNERS": "Partners",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PROJECTS": "Projects",
    "COMPONENTS.ERROR_BOUNDARY.MESSAGE": "An unexpected error occurred",
    "COMPONENTS.ERROR_BOUNDARY.RELOAD": "Reload Page",
    "COMPONENTS.ERROR_BOUNDARY.SHOW_STACK": "Show Error Stack (Development)",
    "COMPONENTS.ERROR_BOUNDARY.TITLE": "Oops! Something went wrong",
    "COMPONENTS.FILE_UPLOAD.BROWSE": "Browse File",
    "COMPONENTS.FILE_UPLOAD.DRAG_TEXT": "Drag & Drop",
    "COMPONENTS.FILE_UPLOAD.ERROR": "File is required",
    "COMPONENTS.FILE_UPLOAD.FILES": "Files",
    "COMPONENTS.FILE_UPLOAD.OR": "Or",
    "COMPONENTS.FILE_UPLOAD.SUPPORTED": "Supports: ",
    "COMPONENTS.FILTER.CLOSE": "Close",
    "COMPONENTS.FILTER.SELECT_A_DMA": "Select a DMA",
    "COMPONENTS.FILTER.SELECT_A_PROJECT": "Select a project",
    "COMPONENTS.FILTER.SELECT_A_SIZE": "Select a size",
    "COMPONENTS.FILTER.SELECT_A_STATUS": "Select a status",
    "COMPONENTS.FILTER.SELECT_DMA": "Select DMA",
    "COMPONENTS.FILTER.SELECT_PROJECT": "Select Project",
    "COMPONENTS.FILTER.SELECT_SIZE": "Select Size",
    "COMPONENTS.FILTER.SELECT_STATUS": "Select Status",
    "COMPONENTS.FUNNEL_CHART.ERROR_MSG": "No Data",
    "COMPONENTS.GRAPH_TOGGLE.SPECTRAL_PROFILE": "Spectral Profile",
    "COMPONENTS.HISTORY_CONTAINER.ACTION": "Action",
    "COMPONENTS.HISTORY_CONTAINER.DATETIME": "Date and Time",
    "COMPONENTS.HISTORY_CONTAINER.ID": "ID",
    "COMPONENTS.HISTORY_CONTAINER.NOTES": "notes",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT": "reference waypoint",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT_ID": "reference waypoint id",
    "COMPONENTS.HISTORY_CONTAINER.SCHEDULED_DATE": "scheduled date",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_CHANGED_FROM_ID": "status changed from id",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_NAME": "changed to status name",
    "COMPONENTS.HISTORY_CONTAINER.TIME_ELAPSED": "Time Elapsed",
    "COMPONENTS.HISTORY_CONTAINER.TITLE": "History from waypoint logs",
    "COMPONENTS.HISTORY_CONTAINER.USER_ID": "user id",
    "COMPONENTS.HISTORY_CONTAINER.USER_NAME": "Author of the modification",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_ID": "waypoint id",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_NAME": "waypoint name",
    "COMPONENTS.ICON_INSIGHT.ALT": "Information icon",
    "COMPONENTS.IMAGE_UPLOAD_BOX.BUTTON_TEXT": "Browse Photo",
    "COMPONENTS.IMAGE_UPLOAD_BOX.DRAG_TEXT": "Drag & Drop",
    "COMPONENTS.IMAGE_UPLOAD_BOX.IMAGE_TYPE": "Supports: *.png, *.jpg and *.jpeg",
    "COMPONENTS.IMAGE_UPLOAD_BOX.OR": "OR",
    "COMPONENTS.INSERT_DATE.ADD.END_DATE": "Add End Date",
    "COMPONENTS.INSERT_DATE.ADD.START_DATE": "Add Start Date",
    "COMPONENTS.INSERT_DATE.DATE.LABEL": "Date",
    "COMPONENTS.INSERT_DATE.DATE.PLACEHOLDER": "Select a Date",
    "COMPONENTS.INSERT_DATE.EDIT.END_DATE": "Edit End Date",
    "COMPONENTS.INSERT_DATE.EDIT.START_DATE": "Edit Start Date",
    "COMPONENTS.INSERT_DATE.FAILURE_DESC": "Please try again the update has been unsuccessful",
    "COMPONENTS.INSERT_DATE.FAILURE_TITLE": "Try again!",
    "COMPONENTS.INSERT_DATE.OK": "OK",
    "COMPONENTS.INSERT_DATE.SUBMIT": "Submit",
    "COMPONENTS.INSERT_DATE.SUCCESS_DESC": "The Date has been updated",
    "COMPONENTS.INSERT_DATE.SUCCESS_TITLE": "Awesome!",
    "COMPONENTS.LEAK_SIZE_FUNNEL.LARGE": "Large leak",
    "COMPONENTS.LEAK_SIZE_FUNNEL.MEDIUM": "Medium leak",
    "COMPONENTS.LEAK_SIZE_FUNNEL.SMALL": "Small leak",
    "COMPONENTS.PAGINATION.PAGE_OF": "{{page}} of {{total}}",
    "COMPONENTS.PAGINATION.ROWS_PER_PAGE": "Rows per page",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_DESC": "Please try again the report has been unsuccessful",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_TITLE": "Try again!",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.OK": "OK",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.POST_PROJECT_DESC": "This report will be emailed to you once you submit",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SELECT_FORMAT": "Select the format",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_DESC": "Your report has been created. Check your email for details",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_TITLE": "Awesome!",
    "COMPONENTS.PROGRESS_BAR.END_DATE": "End Date",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_A": "Pipeline Deployed",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_B": "Pipeline Collected",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_C": "Target Progress",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_D": "Uploaded to FIDO AI",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_E": "Deployed",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_F": "Validated",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_G": "Marked Up for Repair",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_H": "Identified by FIDO AI",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_REDUCTION": "Water saved from predicted leaks, marked leaks for repair, and validated leaks, shown relative to reduction target.",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_TITLE": "Leakage Reduction",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_COVERAGE": "Pipeline Coverage Indicates the fraction of the total pipeline that has been covered, shown as a percentage.",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_TITLE": "Pipeline Coverage",
    "COMPONENTS.PROGRESS_BAR.SESSIONS": "Sessions",
    "COMPONENTS.PROGRESS_BAR.START_DATE": "Start Date",
    "COMPONENTS.PROGRESS_BAR.TARGET_LEAKAGE.ERROR_MSG": "Specify your target for leakage reduction to activate the progress display.",
    "COMPONENTS.PROGRESS_BAR.TARGET_PIPELINE.ERROR_MSG": "Specify your target distance for pipeline coverage to activate the progress display.",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_RESULTS": "Leak Size Results",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.LARGE": "large",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.MEDIUM": "medium",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.SMALL": "small",
    "COMPONENTS.PROPORTIONAL_BAR.NO_LEAKS": "No leaks detected.",
    "COMPONENTS.PROPORTIONAL_BAR.TITLE": "Percentage or Number of Leaks",
    "COMPONENTS.SEARCH_BAR.GENERIC": "Search",
    "COMPONENTS.SEARCH_BAR.SEARCH_COMPANIES": "Search for Companies",
    "COMPONENTS.SEARCH_BAR.SEARCH_PROJECTS": "Search for Projects",
    "COMPONENTS.SEARCH_BAR.SEARCH.DISABLED_TOOLTIP": "Please select a partner or company before using search",
    "COMPONENTS.SEARCH.IMG.ALT": "Search icon",
    "COMPONENTS.SELECT.DESELECT_ALL": "Deselect All",
    "COMPONENTS.SELECT.SELECT_ALL": "Select All",
    "COMPONENTS.SESSION_INFORMATION.CONFIRMED_LEAKS": "Confirmed Leaks",
    "COMPONENTS.SESSION_INFORMATION.NAME": "Name",
    "COMPONENTS.SESSION_INFORMATION.REGION": "Region",
    "COMPONENTS.SESSION_INFORMATION.TITLE": "Information about DMA ID",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CANCEL": "Cancel",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CONFIRM": "Confirm",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_A": "Are you sure you want this session ID",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_B": "to be placed on this Asset Key",
    "COMPONENTS.SESSION_RELOCATION.SUCCESS.REQUEST": "Session Successfully moved",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.ERROR": "Error icon",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.SUCCESS": "Success icon",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.WARNING": "Warning icon",
    "COMPONENTS.STATUS_MODAL.ICON.NEGATIVE.ALT": "Cross indicating failure",
    "COMPONENTS.STATUS_MODAL.ICON.POSITIVE.ALT": "Tick indicating success",
    "COMPONENTS.STATUS_MODAL.OK": "OK",
    "COMPONENTS.WAYPOINT_HEADINGS.CONSUMPTION_PROFILE": "Consumption Profile",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION": "Correlation",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.CONTENT": "This shows the list of correlations with their corresponding sessions in the following format:\n{Correlation ID}: {Session A ID} - {Session B ID}",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.TITLE": "Correlation Dropdown",
    "COMPONENTS.WAYPOINT_HEADINGS.JOB": "Jobs",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.CONTENT": "This dropdown represents session IDs with their corresponding status and last update time in the format:\n{Session ID} : {Status} : {Last Update Time}",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.TITLE": "Session Dropdown",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.ID": "Session ID",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.LAST_UPDATE": "End Time",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.STATUS": "Status",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.TYPE": "Type",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSIONS": "Sessions",
    "COMPONENTS.WAYPOINT_HEADINGS.TOP_SOUND": "Top Sound",
    "COMPONENTS.WAYPOINT_HEADINGS.WAYPOINT_LINK": "Go back to Waypoint",
    "COMPONENTS.WAYPOINT_KEY.LARGEST": "Largest Waypoint",
    "COMPONENTS.WAYPOINT_KEY.LATEST": "Latest Waypoint",
    "COMPONENTS.WAYPOINT_TABLE.NUMBER_ROWS": "Rows per page",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FIVE": "Date Updated",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FOUR": "Engineer Name",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_ONE": "Name",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SEVEN": "Select Waypoint",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SIX": "Date Created",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_THREE": "Status",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_TWO": "Size",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.CORRELATION": "Correlation",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.MARKED_UP": "Marked up",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.OVERNIGHT_SESSION": "Overnight session",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIR_SCHEDULED": "Repair Scheduled",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIRED": "Repaired",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.SCHEDULED": "Scheduled",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TITLE": "Current Status",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TOP_SOUND": "Top sound",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.VALIDATED": "Validated",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.LABEL": "Email",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.PLACEHOLDER": "Enter email",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.LABEL": "Password",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.PLACEHOLDER": "Enter password",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Repeat Password",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Repeat password",
    "CONFIRM_ACCOUNT_PAGE.FORM.SUBMIT": "Confirm",
    "CONFIRM_ACCOUNT_PAGE.SUBTITLE": "Confirm account below",
    "CONFIRM_ACCOUNT_PAGE.TITLE": "Confirm Account",
    "CONSUMPTION_PROFILE_PAGE.CHART_LOAD_FAILED": "Could not load consumption chart data. Try refreshing the page or contact support if the problem persists.",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_INFO_TITLE": "Consumption Information",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_PROFILING": "Consumption Profiling ID",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.DATE_TITLE": "Date Times",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.END_TIME": "End Time",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.EXPECTED_SAMPLES": "Expected Samples",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.START_TIME": "Start Time",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.TITLE": "Consumption Profile Information",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.UPLOADED_SAMPLES": "Uploaded Samples",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.EXPORT": "Export Data from Displayed Range",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.TITLE": "Consumption Profile",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COLLECTED_ENGINEER": "Collected Engineer",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COMPANY": "Company",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.DEPLOYED_ENGINEER": "Deployed Engineer",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LAST_UPDATED": "Days since last update",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LOCATION": "Location",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.POSTCODE": "Postcode",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.TITLE": "Location Data",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.WHAT3WORDS": "What3Words",
    "CONSUMPTION_PROFILE_PAGE.NO_DATA": "No data in displayed range, please try a different range.",
    "CORRELATION_GRAPHS.CORRELATION_IMG_ALT": "Correlation Image",
    "CORRELATION_GRAPHS.NO_RESULTS": "No audio or graphs available for session Id:",
    "CORRELATION_GRAPHS.PAGE_TITLE": "Spectral Profile",
    "CORRELATION_GRAPHS.PSD_IMG_ALT": "PSD for session",
    "CORRELATION_GRAPHS.SESSION_ID": "Session Id",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.DETAILS_TITLE": "Correlation Details",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.LEAK_DISTANCE": "Leak Distance",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_A": "Point A location",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_B": "Point B location",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.SPEED_OF_SOUND": "Speed of sound",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TIMESTAMP": "Timestamp",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TITLE": "Correlation Information",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TOTAL_LENGTH": "Total Length",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.COMPANY": "Company",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.ENGINEER": "Engineer",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.TITLE": "Engineer Information",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.DIAMETER": "Diameter",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.LENGTH": "Length",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.MILLIMETERS": "mm",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.TITLE": "Material Details",
    "CORRELATION_INFO_PAGE.STATUS.CENTRAL": "Central position suspected please check manually",
    "CORRELATION_INFO_PAGE.STATUS.DETECTED": "Correlation has been successful",
    "CORRELATION_INFO_PAGE.STATUS.INCONCLUSIVE": "Inconclusive correlation",
    "CORRELATION_INFO_PAGE.STATUS.NOT_FOUND": "Leak noise not found",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.DESCRIPTION": "Correlation results indicate no presence of a leak.",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.TITLE": "Great news!",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_A": "Suspicious pipe information or out-of-bracket towards point A",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_B": "Suspicious pipe information or out-of-bracket towards point B",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.DESCRIPTION": "Correlation results indicate the presence of a leak.",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.TITLE": "Warning!",
    "CURRENCY.EUR": "Euro",
    "CURRENCY.GBP": "Pound sterling",
    "CURRENCY.USD": "US dollar",
    "DASHBOARD_PAGE.CO2.LABEL": "CO2 Savings",
    "DASHBOARD_PAGE.LEAKS.LABEL": "Number of leaks",
    "DASHBOARD_PAGE.LEAKS.LEGEND.LARGE": "Large",
    "DASHBOARD_PAGE.LEAKS.LEGEND.MEDIUM": "Medium",
    "DASHBOARD_PAGE.LEAKS.LEGEND.SMALL": "Small",
    "DASHBOARD_PAGE.LEAKS.SUBTITLE": "Number of detected leaks",
    "DASHBOARD_PAGE.LEAKS.TITLE": "Leaks Size",
    "DASHBOARD_PAGE.SUBTITLE": "Some other Important information goes here",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.SUBTITLE": "Issues",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.TITLE": "Exception alerts",
    "DASHBOARD_PAGE.SUMMARY.FIDO_FUNNEL": "Fido Funnel",
    "DASHBOARD_PAGE.SUMMARY.FIDO_SCORE": "Fido Score",
    "DASHBOARD_PAGE.SUMMARY.LEAK_TITLE": "Leak information",
    "DASHBOARD_PAGE.SUMMARY.LEAKS_IDENTIFIED": "Leaks Predicted by FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.LOCATE_DMA_BUTTON": "Locate DMA on the Map",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_REPAIRED": "Number marked up for repair",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_SCHEDULED": "Number scheduled",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_VERIFIED_REPAIRED": "Number repaired verified by FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.DELIVERY": "Delivery Performance",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.HEALTH_CHECK": "Health check report",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.POST_PROJECT": "Post-Project Report",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.PROJECT": "Project Status",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.TITLE": "Reports",
    "DASHBOARD_PAGE.SUMMARY.SESSIONS_ANALISED": "Files analysed by FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.COMPANY": "Company Timeline",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.PROJECT": "Project Timeline",
    "DASHBOARD_PAGE.TIME_RANGE.ALL_TIME": "All Time",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_30_DAYS": "Last 30 Days",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_7_DAYS": "Last 7 Days",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_YEAR": "Last Year",
    "DASHBOARD_PAGE.TIME_RANGE.TODAY": "Today",
    "DASHBOARD_PAGE.TITLE": "Dashboard",
    "DASHBOARD_PAGE.TOTAL_LEAKAGE_DETECTED": "Total Leakage Detected",
    "DASHBOARD_PAGE.VIEW_ALL_BTN": "View all Projects",
    "DASHBOARD_PAGE.VOLUMETRICS.SUBTITLE": "Leak Volumetrics",
    "DASHBOARD_PAGE.WATER.ANALYSED_BY": "Sessions analysed by FIDO AI",
    "DASHBOARD_PAGE.WATER.COST": "Cost of water lost",
    "DASHBOARD_PAGE.WATER.COST_PER_YEAR": "USD per Year",
    "DASHBOARD_PAGE.WATER.FIDO_AI": "FIDO AI",
    "DASHBOARD_PAGE.WELCOME": "Welcome",
    "DASHBOARD_PAGE.WELCOME_DESCRIPTION": "Here you can access key data such as coverage, leakage reduction, water loss cost and progress tracking.",
    "DELETE_USER.BTN.CANCEL": "Cancel",
    "DELETE_USER.BTN.CLOSE": "Close Modal",
    "DELETE_USER.BTN.SUBMIT": "Delete",
    "DELETE_USER.DESC": "Deleting this profile will remove all personal data",
    "DELETE_USER.SUCCESS.MSG": "User Successfully removed",
    "DELETE_USER.TITLE": "Delete Profile?",
    "DELETE_USER.VALIDATION.ERROR": "User could not be removed, please try again",
    "DELIVERY_PERFORMANCE_PAGE.COLLECTIONS": "Collections",
    "DELIVERY_PERFORMANCE_PAGE.CONVERSION_RATE": "Conversion rate",
    "DELIVERY_PERFORMANCE_PAGE.COVERED": "Distance Covered",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENT_ACCURACY": "Deployment Accuracy",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENTS": "Deployments",
    "DELIVERY_PERFORMANCE_PAGE.END_DATE": "End Date",
    "DELIVERY_PERFORMANCE_PAGE.HOURS_WORKED": "Hours worked",
    "DELIVERY_PERFORMANCE_PAGE.IN_PROGRESS_WAYPOINTS": "In progress waypoints",
    "DELIVERY_PERFORMANCE_PAGE.KM_COVERED": "km Covered",
    "DELIVERY_PERFORMANCE_PAGE.LEAKS_MARKED_UP": "Leaks marked up",
    "DELIVERY_PERFORMANCE_PAGE.NAME": "Name",
    "DELIVERY_PERFORMANCE_PAGE.NON_LEAKS_MARKED_UP": "Non leaks Marked up",
    "DELIVERY_PERFORMANCE_PAGE.NOT_FOUND_WAYPOINTS": "not found waypoints",
    "DELIVERY_PERFORMANCE_PAGE.START_DATE": "start date",
    "DELIVERY_PERFORMANCE_PAGE.WAYPOINTS_INVESTIGATED": "waypoints investigated",
    "DETAIL_WIDGET.TITLE_A": "Sessions",
    "DETAIL_WIDGET.TITLE_B": "FIDO AI Volumetric Identified",
    "DETAIL_WIDGET.TITLE_C": "Runtime Cost of Water Loss",
    "DIALOG.CONFIRM_DELETE.DESCRIPTION": "Are you sure you want to delete this column?",
    "DIALOG.CONFIRM_DELETE.TITLE": "Confirm",
    "DIALOG.FORGOT_PASSWORD.CLOSE": "Close",
    "DIALOG.FORGOT_PASSWORD.DESCRIPTION": "We will send a password recovery link to user's email address.",
    "DIALOG.FORGOT_PASSWORD.SUBMIT": "Reset password",
    "DIALOG.FORGOT_PASSWORD.TITLE": "Reset password",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.BUTTON": "New Project",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.LABEL": "Project Name",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.PLACEHOLDER": "Enter Project Name",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.SUBMIT": "Add Project",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.TITLE": "Add Project",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.BUTTON": "New Employee",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.LABEL": "Project",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.PLACEHOLDER": "Choose Project",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.LABEL": "Company",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.PLACEHOLDER": "Choose Company",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.LABEL": "Email Address",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.PLACEHOLDER": "Enter Email",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.LABEL": "First Name",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.PLACEHOLDER": "Enter First Name",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.LABEL": "Last Name",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.PLACEHOLDER": "Enter Last Name",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.LABEL": "Role",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.PLACEHOLDER": "Choose Role",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.SUBMIT": "Add Employee",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.TITLE": "Add Employee",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ACTIONS": "Actions",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADD": "Add",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADDRESS": "Address",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.BRANCHES": "Projects ({{ count }})",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NAME": "Project Name",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NO_BRANCHES": "No Projects",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_REPORTS": "Total Reports",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_USERS": "Total Users",
    "EDIT_COMPANY_PAGE.CRUMB": "Manage Company",
    "EDIT_COMPANY_PAGE.DELETE_BRANCH.TITLE": "Are you sure you want to delete this Project?",
    "EDIT_COMPANY_PAGE.DELETE_COMPANY.TITLE": "Are you sure you want to delete this Company?",
    "EDIT_COMPANY_PAGE.DELETE_EMPLOYEE.TITLE": "Are you sure you want to delete this Employee?",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.BUTTON": "Edit Project",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.NAME.PLACEHOLDER": "Enter Project Name",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.SUBMIT": "Update Project",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.TITLE": "Edit Project",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ACTIONS": "Actions",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ADD": "Add",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.BRANCH": "Project",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMAIL": "Email",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMPLOYEES": "Employees ({{ count }})",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NAME": "User Name",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NO_EMPLOYEES": "No employees",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ROLE": "Role",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.STATUS": "Status",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.TOTAL_REPORTS": "Total Custom Reports",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.LABEL": "Address",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.PLACEHOLDER": "Enter Address",
    "EDIT_COMPANY_PAGE.FORM.DELETE": "Delete",
    "EDIT_COMPANY_PAGE.FORM.DISCARD": "Discard",
    "EDIT_COMPANY_PAGE.FORM.EDIT": "Edit",
    "EDIT_COMPANY_PAGE.FORM.NAME.LABEL": "Name",
    "EDIT_COMPANY_PAGE.FORM.NAME.PLACEHOLDER": "Enter Name",
    "EDIT_COMPANY_PAGE.FORM.NO_CHANGES": "No changes",
    "EDIT_COMPANY_PAGE.FORM.SUBMIT": "Save",
    "EDIT_COMPANY_PAGE.TITLE": "Edit Company",
    "EDIT_PARTNER.COUNTRY": "Country",
    "EDIT_PARTNER.PARTNER_CODE": "Partner Code",
    "EDIT_PARTNER.PARTNER_NAME": "Partner Name",
    "EDIT_PARTNER.TITLE": "Edit Partner",
    "EDIT_PROJECT.COMPANY.LABEL": "Company",
    "EDIT_PROJECT.COMPANY.PLACEHOLDER": "Select a company",
    "EDIT_PROJECT.COMPANY.VALIDATION": "A company is required",
    "EDIT_PROJECT.COST_PER_DISTANCE.LABEL": "Cost per Distance",
    "EDIT_PROJECT.COST_PER_DISTANCE.PLACEHOLDER": "Cost per Distance",
    "EDIT_PROJECT.COST_PER_DISTANCE.VALIDATION": "Cost per distance is required",
    "EDIT_PROJECT.DISCARD": "Discard",
    "EDIT_PROJECT.DMAS.LABEL": "DMAs",
    "EDIT_PROJECT.DMAS.NO_MATCHING": "No matching DMAs",
    "EDIT_PROJECT.DMAS.PLACEHOLDER": "Select DMAs",
    "EDIT_PROJECT.END_DATE.LABEL": "End Date",
    "EDIT_PROJECT.END_DATE.PLACEHOLDER": "Select End Date",
    "EDIT_PROJECT.END_DATE.VALIDATION": "End date must be after start date",
    "EDIT_PROJECT.NAME.LABEL": "Project Name",
    "EDIT_PROJECT.NAME.PLACEHOLDER": "Enter Project Name",
    "EDIT_PROJECT.NAME.VALIDATION": "Project name is required",
    "EDIT_PROJECT.NO_CHANGES": "No project information change.",
    "EDIT_PROJECT.START_DATE.LABEL": "Start Date",
    "EDIT_PROJECT.START_DATE.PLACEHOLDER": "Select Start Date",
    "EDIT_PROJECT.START_DATE.VALIDATION": "Start date must be before end date",
    "EDIT_PROJECT.SUBMIT": "Submit",
    "EDIT_PROJECT.TARGET_DISTANCE.LABEL": "Target Distance",
    "EDIT_PROJECT.TARGET_DISTANCE.PLACEHOLDER": "Enter Target Distance",
    "EDIT_PROJECT.TARGET_DISTANCE.VALIDATION": "Target distance is required",
    "EDIT_PROJECT.TARGET_LEAKAGE.LABEL": "Target Leakage",
    "EDIT_PROJECT.TARGET_LEAKAGE.PLACEHOLDER": "Enter Target Leakage",
    "EDIT_PROJECT.TARGET_LEAKAGE.VALIDATION": "Target leakage is required",
    "EDIT_PROJECT.TITLE": "Edit Project",
    "EDIT_USER.PAGE_TITLE": "Edit User",
    "EDIT_USER.RETURN_BTN": "Discard",
    "EDIT_USER.SUBMIT_BTN": "Save User",
    "ERROR.DUPLICATE_EMAIL": "The email address entered already exists",
    "ERROR.DUPLICATE_PROJECT": "The project name already exists",
    "ERROR.NO_DATA": "Data for this user is unavailable at this time",
    "ERROR.REPORT.NO_DATA": "Report has no returned data. Please try changing the date range",
    "ERROR.REQUEST": "An error occurred while processing your request. Please try refreshing the page.",
    "ERROR.SESSION_EXPIRED": "Session expired, please login again",
    "EXPORT_BUTTON.ALL": "Export All",
    "EXPORT_BUTTON.ALL_CSV": "Export All (CSV)",
    "EXPORT_BUTTON.ALL_EXCEL": "Export All (Excel)",
    "EXPORT_BUTTON.ALL_JSON": "Export All (JSON)",
    "EXPORT_BUTTON.ERROR.REQUEST": "Error exporting data",
    "EXPORT_BUTTON.EXPORT": "Export",
    "EXPORT_BUTTON.FILTERED": "Export Filtered",
    "EXPORT_BUTTON.FILTERED_CSV": "Export Filtered (CSV)",
    "EXPORT_BUTTON.FILTERED_EXCEL": "Export Filtered (Excel)",
    "EXPORT_BUTTON.FILTERED_JSON": "Export Filtered (JSON)",
    "EXPORT_BUTTON.SUCCESS.REQUEST": "You should receive an email with the export shortly",
    "FILTERS.DATE_RANGE.TITLE": "Date Range",
    "FILTERS.DIALOG.SUBTITLE.CHANGE": "All filters will be deleted?",
    "FILTERS.DIALOG.SUBTITLE.CLOSE": "Are changes will be deleted",
    "FILTERS.DIALOG.TITLE.CHANGE": "Are you sure you want to change the Data Source?",
    "FILTERS.DIALOG.TITLE.CLOSE": "Are you sure you want to close settings?",
    "FILTERS.FORM.COLUMN.LABEL": "Column",
    "FILTERS.FORM.COLUMN.PLACEHOLDER": "Select column",
    "FILTERS.FORM.SOURCE.LABEL": "Data Source",
    "FILTERS.FORM.SOURCE.PLACEHOLDER": "Select Data Source",
    "FILTERS.FORM.TYPE.LABEL": "Type",
    "FILTERS.FORM.TYPE.PLACEHOLDER": "Select type",
    "FILTERS.FORM.VALUE.LABEL": "Value",
    "FILTERS.FORM.VALUE.PLACEHOLDER": "Select value",
    "FILTERS.MODAL_TITLE": "Settings",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.LABEL": "Email",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Enter your email",
    "FORGOT_PASSWORD_PAGE.FORM.SUBMIT": "Send reset link",
    "FORGOT_PASSWORD_PAGE.RECOVERY_SUCCESS": "Recovery link was sent successfully to your email",
    "FORGOT_PASSWORD_PAGE.SUBTITLE": "Enter your email below",
    "FORGOT_PASSWORD_PAGE.TITLE": "Forgot Password",
    "FORM.LABEL.COMPANY": "Company",
    "FORM.LABEL.COUNTRY": "Country",
    "FORM.LABEL.CURRENCY": "Currency",
    "FORM.LABEL.DIAMETER_UNIT": "Diameter",
    "FORM.LABEL.EMAIL": "Email",
    "FORM.LABEL.FIRST_NAME": "First Name",
    "FORM.LABEL.FLOW_RATE_UNIT": "Flow rate",
    "FORM.LABEL.LAST_NAME": "Last Name",
    "FORM.LABEL.LONG_DISTANCE_UNIT": "Long distance",
    "FORM.LABEL.MEASUREMENT_SYSTEM": "Measurement system",
    "FORM.LABEL.PARTNER": "Partner",
    "FORM.LABEL.PHONE": "Phone",
    "FORM.LABEL.ROLE": "Role",
    "FORM.LABEL.SHORT_DISTANCE_UNIT": "Short distance",
    "FORM.LABEL.VOLUME_UNIT": "Volume",
    "FORM.LABEL.WEIGHT_UNIT": "Weight",
    "FORM.PLACEHOLDER.COMPANY": "Select a company",
    "FORM.PLACEHOLDER.COUNTRY": "Select country",
    "FORM.PLACEHOLDER.CURRENCY": "Select currency",
    "FORM.PLACEHOLDER.DIAMETER_UNIT": "Select diameter",
    "FORM.PLACEHOLDER.FLOW_RATE_UNIT": "Select flow rate",
    "FORM.PLACEHOLDER.LONG_DISTANCE_UNIT": "Select long distance",
    "FORM.PLACEHOLDER.MEASUREMENT_SYSTEM": "Select measurement system",
    "FORM.PLACEHOLDER.PARTNER": "Select a partner",
    "FORM.PLACEHOLDER.PHONE": "Select phone",
    "FORM.PLACEHOLDER.ROLE": "Select a role",
    "FORM.PLACEHOLDER.SHORT_DISTANCE_UNIT": "Select short distance",
    "FORM.PLACEHOLDER.VOLUME_UNIT": "Select volume",
    "FORM.PLACEHOLDER.WEIGHT_UNIT": "Select weight",
    "FORM.VALIDATION.COMPANY": "Company is required",
    "FORM.VALIDATION.COUNTRY": "Country is required",
    "FORM.VALIDATION.CURRENCY": "Currency is required",
    "FORM.VALIDATION.EMAIL": "Email is required",
    "FORM.VALIDATION.FIRST_NAME": "First name is required",
    "FORM.VALIDATION.LAST_NAME": "Last name is required",
    "FORM.VALIDATION.MEASUREMENT_SYSTEM": "Measurement system is required",
    "FORM.VALIDATION.PARTNER": "Partner is required",
    "FORM.VALIDATION.PHONE": "Phone is required",
    "FORM.VALIDATION.ROLE": "Role is required",
    "GIS_ADMIN.ACTION.SELECT": "Select",
    "GIS_ADMIN.DELETE_MODAL.BTN.CANCEL": "Cancel",
    "GIS_ADMIN.DELETE_MODAL.BTN.REMOVE": "Remove",
    "GIS_ADMIN.DELETE_MODAL.ERROR_MSG": "Failed to delete GIS upload",
    "GIS_ADMIN.DELETE_MODAL.TITLE": "Confirm removal of GIS Upload",
    "GIS_ADMIN.PREVIEW_MODAL.BTN.CLOSE": "Close Preview",
    "GIS_ADMIN.PREVIEW_MODAL.ERROR_MSG": "Failed to load the preview",
    "GIS_ADMIN.PREVIEW_MODAL.NO_DATA": "No data to display",
    "GIS_ADMIN.PREVIEW_MODAL.TITLE": "GIS Preview",
    "GIS_ADMIN.SEARCH.PLACEHOLDER": "Search",
    "GIS_ADMIN.SEARCH.TEXT": "Search",
    "GIS_ADMIN.TABLE.HEADERS.A": "Company Name",
    "GIS_ADMIN.TABLE.HEADERS.B": "Date Uploaded",
    "GIS_ADMIN.TABLE.HEADERS.C": "Uploaded By",
    "GIS_ADMIN.TABLE.HEADERS.D": "Action",
    "GIS_ADMIN.TABLE.TITLE": "List of GIS Uploads",
    "GIS_ADMIN.TITLE": "GIS Admin",
    "GIS_UPLOAD.API.GENERIC_ERROR": "Request failed please check the format of the file",
    "GIS_UPLOAD.ASSETS.COLUMN.CREATED_DATE.DESCRIPTION": "Date when the asset was installed",
    "GIS_UPLOAD.ASSETS.COLUMN.DIAMETER.DESCRIPTION": "Diameter of the asset",
    "GIS_UPLOAD.ASSETS.COLUMN.DMA_KEY.DESCRIPTION": "Reference to the Area key that the asset is a part of",
    "GIS_UPLOAD.ASSETS.COLUMN.KEY.DESCRIPTION": "Distinct identifier for each asset on the network",
    "GIS_UPLOAD.ASSETS.COLUMN.SUBTYPE.DESCRIPTION": "Further classification detailing the asset's specific characteristics",
    "GIS_UPLOAD.ASSETS.COLUMN.TYPE.DESCRIPTION": "Classification of the asset based on function",
    "GIS_UPLOAD.BUTTON.DISCARD": "Discard",
    "GIS_UPLOAD.BUTTON.NEXT": "Next",
    "GIS_UPLOAD.DMA.COLUMN.KEY.DESCRIPTION": "Unique identifier for each Area",
    "GIS_UPLOAD.DMA.COLUMN.NAME.DESCRIPTION": "Descriptive name of the Area",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_A": "showing on screen the process of mapping columns",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_B": "showing on screen the process of mapping system fields",
    "GIS_UPLOAD.ERROR_MODAL.BUTTON.CLOSE": "Close",
    "GIS_UPLOAD.ERROR_MODAL.DESC.A": "Map the required columns as shown below",
    "GIS_UPLOAD.ERROR_MODAL.DESC.B": "Map the system fields as shown below",
    "GIS_UPLOAD.ERROR_MODAL.DESC.C": "ALSO",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.A": "Oops! Something went wrong on our end.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.B": "It looks like our system is currently experiencing some issues. Please try again later.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.C": "If the problem persists, feel free to contact our support team.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.D": "An error has occurred",
    "GIS_UPLOAD.ERROR.INVALID_FILE": "Invalid file",
    "GIS_UPLOAD.ERROR.MISSING_FILE": "Missing file",
    "GIS_UPLOAD.FILE_HEADER.BTN.BACK_TO_PROJECT": "Back to project creation",
    "GIS_UPLOAD.FILE_HEADER.BTN.CLOSE_MODAL": "Close Modal",
    "GIS_UPLOAD.FILE_HEADER.BTN.GIS_ADMIN": "View GIS Admin",
    "GIS_UPLOAD.FILE_HEADER.BTN.LINK.GIS_ADMIN": "View GIS Admin",
    "GIS_UPLOAD.FILE_HEADER.BTN.UPLOAD": "Upload",
    "GIS_UPLOAD.FILE_HEADER.COUNTER": "File",
    "GIS_UPLOAD.FILE_HEADER.DISCARD": "Discard File",
    "GIS_UPLOAD.FILE_HEADER.ERROR.PARAGRAPH": "Failure uploading GIS please try again",
    "GIS_UPLOAD.FILE_HEADER.FINAL_STEP": "Final Step",
    "GIS_UPLOAD.FILE_HEADER.LOADING.TEXT": "Loading",
    "GIS_UPLOAD.FILE_HEADER.MODAL.UPLOAD_TXT": "Upload finished! Check the admin page for details below",
    "GIS_UPLOAD.FILE_HEADER.NEXT": "Next",
    "GIS_UPLOAD.FILE_HEADER.NO_FILE": "No files to select",
    "GIS_UPLOAD.FILE_HEADER.PREVIOUS": "Previous",
    "GIS_UPLOAD.FILE_HEADER.RESET": "Back to file uploads",
    "GIS_UPLOAD.FILE_HEADER.SUCCESS.PARAGRAPH": "GIS uploaded Successfully",
    "GIS_UPLOAD.FILE_HEADER.TEXT.PARAGRAPH": "Are you sure you want to upload GIS?",
    "GIS_UPLOAD.FILE_HEADER.TEXT.UPLOAD_PARAGRAPH": "Are you sure you want to upload GIS?",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAP_PREVIEW": "Map Preview",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING": "Column Mapping",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING_FOR": "for",
    "GIS_UPLOAD.INPUT.COMPANY.LABEL": "Select Company",
    "GIS_UPLOAD.INPUT.COMPANY.PLACEHOLDER": "Select Company",
    "GIS_UPLOAD.LOADING": "Loading...",
    "GIS_UPLOAD.MAP_PREVIEW.API.GENERAL_ERROR": "Error Loading Map",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.GIS_ADMIN": "View GIS Admin",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.NEXT": "Next",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.PREVIOUS": "Previous",
    "GIS_UPLOAD.MAP_PREVIEW.TITLE": "Map Preview",
    "GIS_UPLOAD.MAP_PREVIEW.UPLOAD_FINISHED": "Upload finished! Check the admin page for details below",
    "GIS_UPLOAD.PAGE_TITLE": "Upload GIS",
    "GIS_UPLOAD.PIPES.COLUMN.CREATED_DATE.DESCRIPTION": "Date when the pipe record was created or installed",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER_UNITS.DESCRIPTION": "Measurement units for the pipe diameter",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER.DESCRIPTION": "Diameter of the pipe, units specified separately",
    "GIS_UPLOAD.PIPES.COLUMN.DMA_KEY.DESCRIPTION": "Reference to the Area key that the pipe is a part of",
    "GIS_UPLOAD.PIPES.COLUMN.KEY.DESCRIPTION": "Distinct identifier for each pipe on the network",
    "GIS_UPLOAD.PIPES.COLUMN.MATERIAL.DESCRIPTION": "Primary construction material of the pipe",
    "GIS_UPLOAD.PIPES.COLUMN.STATUS.DESCRIPTION": "Whether the pipe is in Active Service, Abandoned, Removed, etc.",
    "GIS_UPLOAD.PIPES.COLUMN.SUBTYPE.DESCRIPTION": "Specific classification of pipe based on function or structure",
    "GIS_UPLOAD.PIPES.COLUMN.TYPE.DESCRIPTION": "What service the pipe performs: Mains Distribution, Service Line, Trunk Main, etc.",
    "GIS_UPLOAD.ROUTES.STEP_FIVE": "Map Preview",
    "GIS_UPLOAD.ROUTES.STEP_FOUR": "Process Assets",
    "GIS_UPLOAD.ROUTES.STEP_ONE": "Upload Shapefile",
    "GIS_UPLOAD.ROUTES.STEP_THREE": "Process Pipes",
    "GIS_UPLOAD.ROUTES.STEP_TWO": "Process DMA",
    "GIS_UPLOAD.STATUS.FILE_FETCHING": "File data is fetching...",
    "GIS_UPLOAD.STATUS.FILE_LOADING": "File data is loading...",
    "GIS_UPLOAD.STATUS.FILE_UPLOADING": "File is uploading...",
    "GIS_UPLOAD.STATUS.LOADING_COMPANIES_DATA": "Loading companies data...",
    "GIS_UPLOAD.STATUS.UPLOADING_FILE": "Uploading a file...",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN": "Create column",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN_ERROR": "Something went wrong: could not create column",
    "GIS_UPLOAD.TABLE.INVALID_MAPPING": "This column is invalid for the selected data type",
    "GIS_UPLOAD.TABLE.MAPPING_TITLE": "Mapping Selected Columns",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.DELETE": "Delete",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.SAVE": "Save changes",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE": "Column type",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE.PLACEHOLDER": "Select column type",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS": "Units",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS.PLACEHOLDER": "Select units",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE": "Value",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL": "Value",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL.PLACEHOLDER": "Enter a value for all cells in the column",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE.PLACEHOLDER": "Select a value for all cells in the column",
    "GIS_UPLOAD.TABLE.NO_MAPPING_OPTIONS": "No mapping options",
    "GIS_UPLOAD.TABLE.SELECT_COLUMN": "Please select a column",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN": "Update column",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN_ERROR": "Something went wrong: could not update column",
    "GIS_UPLOAD.UPLOAD.ERROR": "Uploading error, try again.",
    "GIS_UPLOAD.UPLOAD.LABEL": "Upload Shapefile",
    "HEADER.BROWSE": "Browse",
    "HEADER.COMPANIES": "Companies",
    "HEADER.CONSUMPTION_PROFILE": "Consumption Profile",
    "HEADER.CORRELATION": "Correlation",
    "HEADER.DASHBOARD": "Dashboard",
    "HEADER.DPLE": "Delivery performance Leak Engineer",
    "HEADER.DPST": "Delivery Performance Sensor Technician",
    "HEADER.GIS_ADMIN": "GIS Admin",
    "HEADER.GIS_UPLOAD": "GIS Upload",
    "HEADER.HOME": "Home",
    "HEADER.JOB_DETAILS": "Job Details",
    "HEADER.LOGS": "Change Logs",
    "HEADER.PROFILE": "Profile",
    "HEADER.PROJECT_STATUS": "Project Status",
    "HEADER.RELAY_MANAGEMENT": "Relay Management",
    "HEADER.REPORTS": "Reports",
    "HEADER.SENSOR_MANAGEMENT": "Sensor Management",
    "HEADER.SESSION": "Session Information",
    "HEADER.STOCK_MANAGEMENT": "Stock Management",
    "HEADER.TOP_SOUND": "Top Sound",
    "HEADER.USERS": "User Management",
    "HEADER.WAYPOINT": "Waypoint",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_GRAPHS": "No historical or overnight graphs available",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_HISTORICAL_GRAPHS": "No historical Graphs available",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_OVERNIGHT_GRAPHS": "No overnight Graph available",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.HISTORICAL": "Historical session graph",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.OVERNIGHT": "Overnight session graph",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.HISTORY": "History",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.OVERNIGHT": "Overnight",
    "HOME_PAGE.DESCRIPTION": "Welcome to the Hub where you can manage tasks, support users and view all the data from your FIDO Smart service. What can we help with today?",
    "HOME_PAGE.HELLO": "Hello, {{name}}",
    "HOME_PAGE.HERO_IMAGE_ALT": "Hero image",
    "HOME_PAGE.LOCATE_LEAKS.DESCRIPTION": "Browse waypoints by size and monitor investigations",
    "HOME_PAGE.LOCATE_LEAKS.TITLE": "Locate leaks",
    "HOME_PAGE.MANAGE_PROJECTS.DESCRIPTION": "Monitor project progress and view past activity",
    "HOME_PAGE.MANAGE_PROJECTS.TITLE": "Manage projects",
    "HOME_PAGE.MONITOR_NETWORK.DESCRIPTION": "Manage your fixed sensors and optimize connectivity",
    "HOME_PAGE.MONITOR_NETWORK.TITLE": "Monitor your network",
    "HOME_PAGE.NO_ACTIVITIES_FOUND": "No activities found",
    "HOME_PAGE.YOUR_DASHBOARDS.DESCRIPTION": "Analyse and report on key performance data",
    "HOME_PAGE.YOUR_DASHBOARDS.TITLE": "Your dashboards",
    "HOME_PAGE.YOUR_LATEST_ACTIVITIES": "Your latest activities",
    "INVITATIONS.ACCEPT.CONTEXT.EMAIL": "Email",
    "INVITATIONS.ACCEPT.CONTEXT.NOT_PROVIDED": "Not provided",
    "INVITATIONS.ACCEPT.CONTEXT.ORGANIZATION": "Organization",
    "INVITATIONS.ACCEPT.CONTEXT.ROLE": "Role",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.DESCRIPTION": "Sign in with your existing account to continue.",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.TITLE": "Invitation already accepted",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.DESCRIPTION": "This invitation is no longer active. Contact your administrator if you still need access.",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.TITLE": "Invitation cancelled",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.DESCRIPTION": "This invitation link is no longer active. Request a new invitation from your administrator.",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.TITLE": "Invitation expired",
    "INVITATIONS.ACCEPT.ERROR.INVALID.DESCRIPTION": "This invitation is invalid or has expired. Request a new invitation from your administrator.",
    "INVITATIONS.ACCEPT.ERROR.INVALID.TITLE": "Invalid invitation",
    "INVITATIONS.ACCEPT.ERROR.SUBMIT_FAILURE": "Failed to accept invitation",
    "INVITATIONS.ACCEPT.FIELDS.CONFIRM_PASSWORD": "Confirm password",
    "INVITATIONS.ACCEPT.FIELDS.COUNTRY": "Country",
    "INVITATIONS.ACCEPT.FIELDS.CURRENCY": "Currency",
    "INVITATIONS.ACCEPT.FIELDS.DIAMETER": "Diameter",
    "INVITATIONS.ACCEPT.FIELDS.FIRST_NAME": "First name",
    "INVITATIONS.ACCEPT.FIELDS.FLOW_RATE": "Flow rate",
    "INVITATIONS.ACCEPT.FIELDS.LAST_NAME": "Last name",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_ARIA": "Accept the privacy policy and terms and conditions",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_CONJUNCTION": "and",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_PREFIX": "I accept the",
    "INVITATIONS.ACCEPT.FIELDS.LONG_DISTANCE": "Long distance",
    "INVITATIONS.ACCEPT.FIELDS.MEASUREMENT_SYSTEM": "Measurement system",
    "INVITATIONS.ACCEPT.FIELDS.PASSWORD": "Password",
    "INVITATIONS.ACCEPT.FIELDS.PHONE": "Phone",
    "INVITATIONS.ACCEPT.FIELDS.SELECT_PLACEHOLDER": "Select",
    "INVITATIONS.ACCEPT.FIELDS.SHORT_DISTANCE": "Short distance",
    "INVITATIONS.ACCEPT.FIELDS.VOLUME": "Volume",
    "INVITATIONS.ACCEPT.FIELDS.WEIGHT": "Weight",
    "INVITATIONS.ACCEPT.FORM_ARIA_LABEL": "Accept invitation",
    "INVITATIONS.ACCEPT.LINKS.PRIVACY_POLICY": "Privacy policy",
    "INVITATIONS.ACCEPT.LINKS.TERMS_AND_CONDITIONS": "Terms and conditions",
    "INVITATIONS.ACCEPT.LOADING": "Loading invitation",
    "INVITATIONS.ACCEPT.SUBMIT": "Create account",
    "INVITATIONS.ACCEPT.SUBMITTING": "Accepting invitation…",
    "INVITATIONS.ACCEPT.SUCCESS.DESCRIPTION": "Your account is ready. Sign in to continue.",
    "INVITATIONS.ACCEPT.SUCCESS.SIGN_IN_CTA": "Sign in",
    "INVITATIONS.ACCEPT.SUCCESS.TITLE": "Your account is ready",
    "INVITATIONS.ACCEPT.TITLE": "Accept invitation",
    "INVITATIONS.ACTION.CANCEL": "Cancel",
    "INVITATIONS.ACTION.SUBMIT": "Send invitation",
    "INVITATIONS.DIALOG.DESCRIPTION": "Invite a user by email. They will appear in the users list after they accept the invitation.",
    "INVITATIONS.DIALOG.TITLE": "Invite user",
    "INVITATIONS.SUCCESS.SENT": "Invitation sent. The user will appear in the users list after they accept the invitation.",
    "INVITATIONS.VALIDATION.DIAMETER": "Diameter unit is required",
    "INVITATIONS.VALIDATION.FLOW_RATE": "Flow rate unit is required",
    "INVITATIONS.VALIDATION.GENERIC": "There was an issue with inviting this user. Please check the information and try again.",
    "INVITATIONS.VALIDATION.LEGAL_ACCEPTANCE": "Privacy policy and terms must be accepted",
    "INVITATIONS.VALIDATION.LONG_DISTANCE": "Long distance unit is required",
    "INVITATIONS.VALIDATION.PASSWORD_COMPLEXITY": "Password must contain at least three of: lowercase, uppercase, numeric, and special characters",
    "INVITATIONS.VALIDATION.PASSWORD_MAX": "Password should be at most 64 characters",
    "INVITATIONS.VALIDATION.SHORT_DISTANCE": "Short distance unit is required",
    "INVITATIONS.VALIDATION.VOLUME": "Volume unit is required",
    "INVITATIONS.VALIDATION.WEIGHT": "Weight unit is required",
    "JOB_DETAILS.ADDRESS": "Leak Address",
    "JOB_DETAILS.AI_LEAK": "AI Predicted Leak Size",
    "JOB_DETAILS.BACK_BUTTON": "Go back to Waypoint",
    "JOB_DETAILS.CANCEL": "Cancel",
    "JOB_DETAILS.COMMENTS": "Notes",
    "JOB_DETAILS.DATE_INFO_TITLE": "Date Information",
    "JOB_DETAILS.DATE_SECTION.CREATED": "Created Date",
    "JOB_DETAILS.DATE_SECTION.REPAIR": "Repair Date",
    "JOB_DETAILS.DATE_SECTION.TITLE": "Date Times",
    "JOB_DETAILS.DATE_SECTION.UPDATED": "Updated Date",
    "JOB_DETAILS.DMA": "DMA Reference",
    "JOB_DETAILS.EDIT": "Edit Job Details",
    "JOB_DETAILS.ENGINEER": "Assigned Engineer",
    "JOB_DETAILS.ENVIRONMENTAL_NOTE": "Environmental Note",
    "JOB_DETAILS.ERROR": "Failed to update job",
    "JOB_DETAILS.FLOW": "Flow Reduction",
    "JOB_DETAILS.FLOW_REDUCTION": "Agreed Flow Reduction",
    "JOB_DETAILS.ID": "Job ID",
    "JOB_DETAILS.JOB_IMAGES_TITLE": "Job Images",
    "JOB_DETAILS.JOB_INFO_TITLE": "Job Information",
    "JOB_DETAILS.LEAK": "Client Leak Size Estimate",
    "JOB_DETAILS.LEAK_SIZE": "Estimated Leak Size",
    "JOB_DETAILS.LEAK_TYPE": "On Site Leak Type Estimate",
    "JOB_DETAILS.LOCATION_INFO_TITLE": "Location Information",
    "JOB_DETAILS.MATERIAL": "Pipe Material",
    "JOB_DETAILS.NO_IMAGES": "No images",
    "JOB_DETAILS.NO_JOB": "Job not found with id",
    "JOB_DETAILS.NOMINAL": "Client Leak Size Estimate/ Nominal Volume",
    "JOB_DETAILS.NOTES": "Environmental Notes",
    "JOB_DETAILS.PROJECT": "Project",
    "JOB_DETAILS.ROAD_SPEED": "Road Speed",
    "JOB_DETAILS.SAVE": "Save",
    "JOB_DETAILS.SIZE": "Pipe Size",
    "JOB_DETAILS.STATUS": "Job Status",
    "JOB_DETAILS.SURFACE": "Surface Type",
    "JOB_DETAILS.TITLE": "Job Details",
    "JOB_DETAILS.TYPE": "Job Type",
    "JOB_DETAILS.W3W": "What3Words",
    "JOB_DETAILS.WAYPOINT": "Waypoint ID",
    "JOB_DETAILS.WAYPOINT_STATUS": "Waypoint Status",
    "JOB_DETAILS.WORK_ORDER": "Client/Utility's Work Order Reference",
    "LANGUAGE.ENGLISH": "English",
    "LANGUAGE.FRENCH": "French",
    "LANGUAGE.ITALIAN": "Italian",
    "LANGUAGE.POLISH": "Polish",
    "LANGUAGE.SPANISH": "Spanish",
    "LIST_VIEW.CONSUMPTION_PROFILE": "Consumption Profiling",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_FROM": "Date From",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TO": "Date To",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TYPE": "Date Type",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.awaiting_upload": "Awaiting Upload",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.completed": "Completed",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.deleted": "Deleted",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.in_progress": "In Progress",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.BUTTON_LABEL": "Customize View",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.DESCRIPTION": "Drag column headings to rearrange the order, tick/untick to show/hide the table columns.",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.RESET_BUTTON_LABEL": "Reset to Default View",
    "LIST_VIEW.CONSUMPTION_PROFILE.FILTER_SECTION": "Filter",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.address": "Address",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.collected_by": "Collected By",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.company": "Company",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.deployed_by": "Deployed By",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.dma_key": "DMA",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_date": "End date",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_time": "End time",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.id": "ID",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.latitude": "Latitude",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.longitude": "Longitude",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.partner": "Partner",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.project": "Project",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_date": "Start date",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_time": "Start time",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_id": "Waypoint ID",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_name": "Waypoint Name",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.what3words": "What3Words",
    "LIST_VIEW.CONSUMPTION_PROFILE.NO_DATA": "No data available",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.APPLY.FILTER": "Apply Filters",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.RESET": "Reset All Filters",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH.PLACEHOLDER": "Search...",
    "LIST_VIEW.CONSUMPTION_PROFILE.TITLE": "Browse All Consumption Profiling",
    "LIST_VIEW.JOBS": "Jobs",
    "LIST_VIEW.JOBS.HEADERS.address": "Address",
    "LIST_VIEW.JOBS.HEADERS.agreed_flow_reduction": "Agreed Flow Reduction",
    "LIST_VIEW.JOBS.HEADERS.branch_id": "Project",
    "LIST_VIEW.JOBS.HEADERS.client_leak_size_estimate": "Client Leak Size Estimate",
    "LIST_VIEW.JOBS.HEADERS.comment": "Comment",
    "LIST_VIEW.JOBS.HEADERS.created_at": "Created",
    "LIST_VIEW.JOBS.HEADERS.date_raised_externally": "Date Raised Externally",
    "LIST_VIEW.JOBS.HEADERS.date_raised_internally": "Date Raised Internally",
    "LIST_VIEW.JOBS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.JOBS.HEADERS.environmental_notes": "Environmental Notes",
    "LIST_VIEW.JOBS.HEADERS.estimate_leak_size": "Estimated Leak Size",
    "LIST_VIEW.JOBS.HEADERS.id": "ID",
    "LIST_VIEW.JOBS.HEADERS.job_status": "Job Status",
    "LIST_VIEW.JOBS.HEADERS.last_scheduled_engineer_id": "Engineer",
    "LIST_VIEW.JOBS.HEADERS.leak_type": "Job Code",
    "LIST_VIEW.JOBS.HEADERS.material": "Material",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter": "Pipe Size",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter_unit": "Pipe Size Unit",
    "LIST_VIEW.JOBS.HEADERS.repair_date": "Repair Date",
    "LIST_VIEW.JOBS.HEADERS.road_speed": "Road Speed",
    "LIST_VIEW.JOBS.HEADERS.updated_at": "Updated",
    "LIST_VIEW.JOBS.HEADERS.waypoint_id": "Waypoint",
    "LIST_VIEW.JOBS.HEADERS.work_order": "Work Order",
    "LIST_VIEW.JOBS.SUMMARY.JOB_TYPE": "Job Type",
    "LIST_VIEW.JOBS.SUMMARY.SESSION_TYPE": "Session Type",
    "LIST_VIEW.JOBS.TITLE": "Browse All Jobs",
    "LIST_VIEW.RELAYS": "Relay Devices",
    "LIST_VIEW.RELAYS.HEADERS.address": "Address",
    "LIST_VIEW.RELAYS.HEADERS.bug_id": "Mac Address",
    "LIST_VIEW.RELAYS.HEADERS.bug_mac": "Mac Address",
    "LIST_VIEW.RELAYS.HEADERS.company": "Company",
    "LIST_VIEW.RELAYS.HEADERS.company_name": "Company",
    "LIST_VIEW.RELAYS.HEADERS.create_time": "Created Time",
    "LIST_VIEW.RELAYS.HEADERS.dma_name": "DMA",
    "LIST_VIEW.RELAYS.HEADERS.last_contact": "Last Contact",
    "LIST_VIEW.RELAYS.HEADERS.last_update": "Last Upload",
    "LIST_VIEW.RELAYS.HEADERS.latitude": "Latitude",
    "LIST_VIEW.RELAYS.HEADERS.longitude": "Longitude",
    "LIST_VIEW.RELAYS.HEADERS.partner": "Partner",
    "LIST_VIEW.RELAYS.HEADERS.partner_name": "Partner",
    "LIST_VIEW.RELAYS.HEADERS.project": "Project",
    "LIST_VIEW.RELAYS.HEADERS.project_name": "Project",
    "LIST_VIEW.RELAYS.HEADERS.relay_id": "Relay ID",
    "LIST_VIEW.RELAYS.HEADERS.relay_name": "Relay Name",
    "LIST_VIEW.RELAYS.HEADERS.relay_status": "Relay Status",
    "LIST_VIEW.RELAYS.HEADERS.relay_uptime": "Relay Uptime",
    "LIST_VIEW.RELAYS.HEADERS.session_id": "Session",
    "LIST_VIEW.RELAYS.HEADERS.session_leak_size": "Session AI Predicted Size",
    "LIST_VIEW.RELAYS.HEADERS.update_time": "Update Time",
    "LIST_VIEW.RELAYS.HEADERS.what3words": "What3Words",
    "LIST_VIEW.RELAYS.TITLE": "Browse All Relay Devices",
    "LIST_VIEW.SELECT_DATA_TYPE.LABEL": "Data Type",
    "LIST_VIEW.SELECT_DATA_TYPE.PLACEHOLDER": "Select data type",
    "LIST_VIEW.SESSIONS": "Sessions",
    "LIST_VIEW.SESSIONS.DATE_FROM": "Date From",
    "LIST_VIEW.SESSIONS.DATE_TO": "Date To",
    "LIST_VIEW.SESSIONS.DATE_TYPE": "Date Type",
    "LIST_VIEW.SESSIONS.DISTINCT.awaiting_upload": "Awaiting Upload",
    "LIST_VIEW.SESSIONS.DISTINCT.completed": "Completed",
    "LIST_VIEW.SESSIONS.DISTINCT.deleted": "Deleted",
    "LIST_VIEW.SESSIONS.DISTINCT.in_progress": "In Progress",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.BUTTON_LABEL": "Customize View",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.DESCRIPTION": "Drag column headings to rearrange the order, tick/untick to show/hide the table columns.",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.RESET_BUTTON_LABEL": "Reset to Default View",
    "LIST_VIEW.SESSIONS.FILTER_SECTION": "Filter",
    "LIST_VIEW.SESSIONS.HEADERS.address": "Address",
    "LIST_VIEW.SESSIONS.HEADERS.asset_id": "Asset",
    "LIST_VIEW.SESSIONS.HEADERS.collected_by": "Collected By",
    "LIST_VIEW.SESSIONS.HEADERS.company_id": "Company",
    "LIST_VIEW.SESSIONS.HEADERS.created": "Created Date",
    "LIST_VIEW.SESSIONS.HEADERS.deployed_by": "Deployed By",
    "LIST_VIEW.SESSIONS.HEADERS.dma_id": "DMA",
    "LIST_VIEW.SESSIONS.HEADERS.end_time": "End Date",
    "LIST_VIEW.SESSIONS.HEADERS.expected_finish": "Expected Finish",
    "LIST_VIEW.SESSIONS.HEADERS.last_update": "Last Updated",
    "LIST_VIEW.SESSIONS.HEADERS.latitude": "Latitude",
    "LIST_VIEW.SESSIONS.HEADERS.leak_size": "Predicted Size",
    "LIST_VIEW.SESSIONS.HEADERS.longitude": "Longitude",
    "LIST_VIEW.SESSIONS.HEADERS.partner_id": "Partner",
    "LIST_VIEW.SESSIONS.HEADERS.project_id": "Project",
    "LIST_VIEW.SESSIONS.HEADERS.relay_connected": "Relay Connected",
    "LIST_VIEW.SESSIONS.HEADERS.sensor-id": "Sensor ID",
    "LIST_VIEW.SESSIONS.HEADERS.session_id": "Session ID",
    "LIST_VIEW.SESSIONS.HEADERS.start_time": "Start Date",
    "LIST_VIEW.SESSIONS.HEADERS.status_id": "Status",
    "LIST_VIEW.SESSIONS.HEADERS.type": "Session Type",
    "LIST_VIEW.SESSIONS.HEADERS.what3words": "W3W",
    "LIST_VIEW.SESSIONS.NO_DATA": "No data available",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.APPLY.FILTER": "Apply Filters",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.RESET": "Reset All Filters",
    "LIST_VIEW.SESSIONS.SEARCH.PLACEHOLDER": "Search...",
    "LIST_VIEW.SESSIONS.SUMMARY.LEAK_SIZE": "Leak Size",
    "LIST_VIEW.SESSIONS.SUMMARY.SESSION_TYPE": "Session Type",
    "LIST_VIEW.SESSIONS.SUMMARY.TITLE": "Summary",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.DESC": "To adjust the data displayed here, use the filters from the table above.",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.TITLE": "Summary of resulting data",
    "LIST_VIEW.SESSIONS.SUMMARY.WAYPOINT_STATUS": "Waypoint Status",
    "LIST_VIEW.SESSIONS.TITLE": "Browse All Sessions",
    "LIST_VIEW.WAYPOINT_LOGS": "Logs",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_from_status_name": "Previous Status",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_to_status_name": "Current Status",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.company": "Company",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.datetime": "Update Date",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.id": "ID",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.notes": "Notes",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.partner": "Partner",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.project": "Project",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.user_name": "Username",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.waypoint_id": "Waypoint",
    "LIST_VIEW.WAYPOINT_LOGS.TITLE": "Browse All Waypoint Logs",
    "LIST_VIEW.WAYPOINTS": "Waypoints",
    "LIST_VIEW.WAYPOINTS.HEADERS.address": "Address",
    "LIST_VIEW.WAYPOINTS.HEADERS.agreed_flow_reduction": "Agreed Flow Reduction",
    "LIST_VIEW.WAYPOINTS.HEADERS.branch_name": "Project",
    "LIST_VIEW.WAYPOINTS.HEADERS.comment": "Comment",
    "LIST_VIEW.WAYPOINTS.HEADERS.company_id": "Company",
    "LIST_VIEW.WAYPOINTS.HEADERS.created_at": "Created At",
    "LIST_VIEW.WAYPOINTS.HEADERS.date_time": "Update Date",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter": "Diameter",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter_unit": "Diameter Unit",
    "LIST_VIEW.WAYPOINTS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINTS.HEADERS.environmental_notes": "Environmental Notes",
    "LIST_VIEW.WAYPOINTS.HEADERS.estimated_size": "Estimated Size",
    "LIST_VIEW.WAYPOINTS.HEADERS.job_type_code": "Job Type Code",
    "LIST_VIEW.WAYPOINTS.HEADERS.jobs": "Jobs",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_action_by": "Last Action By",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_scheduled_engineer_id": "Last Scheduled Engineer",
    "LIST_VIEW.WAYPOINTS.HEADERS.latitude": "Latitude",
    "LIST_VIEW.WAYPOINTS.HEADERS.longitude": "Longitude",
    "LIST_VIEW.WAYPOINTS.HEADERS.material": "Material",
    "LIST_VIEW.WAYPOINTS.HEADERS.name": "Name",
    "LIST_VIEW.WAYPOINTS.HEADERS.partner_id": "Partner",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_leak_type_id": "Predicted Leak Type",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_size": "Predicted Size",
    "LIST_VIEW.WAYPOINTS.HEADERS.sessions": "Sessions",
    "LIST_VIEW.WAYPOINTS.HEADERS.status_id": "Status",
    "LIST_VIEW.WAYPOINTS.HEADERS.surface_type": "Surface Type",
    "LIST_VIEW.WAYPOINTS.HEADERS.w3w": "What3Words",
    "LIST_VIEW.WAYPOINTS.TITLE": "Browse All Waypoints",
    "LOGIN_PAGE.ENTRA_TITLE": "Sign in to Portal",
    "LOGIN_PAGE.ERROR.MSG": "Incorrect email or password",
    "LOGIN_PAGE.FORGOT_PASSWORD": "Forgot Password?",
    "LOGIN_PAGE.FORM.EMAIL.LABEL": "Email",
    "LOGIN_PAGE.FORM.EMAIL.PLACEHOLDER": "Enter your email",
    "LOGIN_PAGE.FORM.OKTA_SUBMIT": "Login with Okta",
    "LOGIN_PAGE.FORM.PASSWORD.LABEL": "Password",
    "LOGIN_PAGE.FORM.PASSWORD.PLACEHOLDER": "Enter your password",
    "LOGIN_PAGE.FORM.SUBMIT": "Sign In",
    "LOGIN_PAGE.SIGNING_IN": "Signing you in…",
    "LOGIN_PAGE.SIGNING_IN_SUBTITLE": "If you’re not redirected automatically in a few seconds, please refresh the page.",
    "LOGIN_PAGE.SUBTITLE": "Enter your email and password below",
    "LOGIN_PAGE.TITLE": "Sign In to Admin Panel",
    "LOGS.ACTION.ASSIGN_DMAs": "Assign DMAs",
    "LOGS.ACTION.CHANGE DATES": "Change Dates",
    "LOGS.ACTION.Change project 1 dates": "Change Project 1 Dates",
    "LOGS.ACTION.CHANGE_DATES": "Change Dates",
    "LOGS.ACTION.CHANGE_PASSWORD": "Change Password",
    "LOGS.ACTION.CREATE PROJECT": "Create Project",
    "LOGS.ACTION.CREATE_BRANCH": "Create Branch",
    "LOGS.ACTION.CREATE_COMPANY": "Create Company",
    "LOGS.ACTION.CREATE_MULTI_USER": "Create Multiple Users",
    "LOGS.ACTION.CREATE_PARTNER": "Create Partner",
    "LOGS.ACTION.CREATE_PROJECT": "Create Project",
    "LOGS.ACTION.CREATE_USER": "Create User",
    "LOGS.ACTION.DELETE_BRANCH": "Delete Branch",
    "LOGS.ACTION.DELETE_COMPANY": "Delete Company",
    "LOGS.ACTION.DELETE_DMAs": "Delete DMAs",
    "LOGS.ACTION.DELETE_PARTNER": "Delete Partner",
    "LOGS.ACTION.DELETE_PROJECT": "Delete Project",
    "LOGS.ACTION.DELETE_USER": "Delete User",
    "LOGS.ACTION.EDIT_COMPANY": "Edit Company",
    "LOGS.ACTION.FORGOT_PASSWORD": "Forgot Password",
    "LOGS.ACTION.GET_COMPANY": "Get Company",
    "LOGS.ACTION.LOGIN": "Login",
    "LOGS.ACTION.MODIFY_COMPANY": "Modify Company",
    "LOGS.ACTION.MODIFY_PARTNER": "Modify Partner",
    "LOGS.ACTION.MODIFY_USER": "Modify User",
    "LOGS.ACTION.REACTIVATE_COMPANY": "Reactivate Company",
    "LOGS.ACTION.REACTIVATE_PARTNER": "Reactivate Partner",
    "LOGS.ACTION.RESTORE_COMPANY": "Restore Company",
    "LOGS.ACTION.SET_PASSWORD": "Set Password",
    "LOGS.ACTION.TOGGLE OFF RELAY DEVICE": "Toggle Off Relay Device",
    "LOGS.ACTION.TRIGGER RELAY DEVICE": "Trigger Relay Device",
    "LOGS.ACTION.UPDATE WAYPOINT": "Update Waypoint",
    "LOGS.ACTION.UPDATE_BRANCH": "Update Branch",
    "LOGS.ACTION.UPDATE_LOGGER_SESSION": "Update Logger Session",
    "LOGS.DESCRIPTION.ASSIGN_DMAs": "Assigned DMAs {{dma_keys}} to {{project_name}}",
    "LOGS.DESCRIPTION.CHANGE_DATES": "Changed dates for {{project_name}}. Start date: {{start_date}}. End date: {{end_date}}",
    "LOGS.DESCRIPTION.COMMON.BY_USER_EMAIL": "by {{by_email}}",
    "LOGS.DESCRIPTION.CREATE_BRANCH": "Created project {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_COMPANY": "Created company {{company_name}}",
    "LOGS.DESCRIPTION.CREATE_PROJECT": "Created project {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_USER": "Created user {{user_name}}:{{user_email}}",
    "LOGS.DESCRIPTION.DELETE_PROJECT": "Deleted project {{project_name}}",
    "LOGS.DESCRIPTION.DELETE_USER": "Deleted user {{user_name}}:{{user_email}}",
    "LOGS.DESCRIPTION.MODIFY_COMPANY": "Modified company {{company_name}}",
    "LOGS.DESCRIPTION.MODIFY_PARTNER": "Modified partner {{partner_name}}",
    "LOGS.DESCRIPTION.MODIFY_USER": "Modified user {{user_name}}:{{user_email}}",
    "LOGS.DESCRIPTION.UPDATE_LOGGER_SESSION": "Updated logger session {{session_id}}",
    "MAP_UNITS.TITLE.COLUMN": "Map column",
    "MAP_UNITS.TITLE.UNITS": "Map unit values",
    "MAP_VIEW.DIALOG.SUBTITLE.CHANGE": "All filters will be deleted?",
    "MAP_VIEW.DIALOG.SUBTITLE.CLOSE": "Are changes will be deleted",
    "MAP_VIEW.DIALOG.TITLE.CHANGE": "Are you sure you want to change the Data Source?",
    "MAP_VIEW.DIALOG.TITLE.CLOSE": "Are you sure you want to close settings?",
    "MAP_VIEW.FILTERS.BUTTONTITLE": "Map Options",
    "MAP_VIEW.FILTERS.SUBMIT": "Submit",
    "MAP_VIEW.FILTERS.TITLES.ASSETS": "Assets",
    "MAP_VIEW.FILTERS.TITLES.AWAITING_UPLOAD_SESSION": "Awaiting Upload Session",
    "MAP_VIEW.FILTERS.TITLES.DELETED_SESSION": "Deleted Session",
    "MAP_VIEW.FILTERS.TITLES.DMAS": "DMAs",
    "MAP_VIEW.FILTERS.TITLES.IN_PROGRESS_SESSION": "In Progress Session",
    "MAP_VIEW.FILTERS.TITLES.INVESTIGATION_SESSION": "Investigation Session",
    "MAP_VIEW.FILTERS.TITLES.LARGE_LEAK_SESSION": "Large Leak Session",
    "MAP_VIEW.FILTERS.TITLES.MEDIUM_LEAK_SESSION": "Medium leak Session",
    "MAP_VIEW.FILTERS.TITLES.NON_LEAK_SESSION": "Non Leak Session",
    "MAP_VIEW.FILTERS.TITLES.ODL": "ODL",
    "MAP_VIEW.FILTERS.TITLES.PIPES": "Pipes",
    "MAP_VIEW.FILTERS.TITLES.SMALL_LEAK_SESSION": "Small leak Session",
    "MAP_VIEW.FILTERS.TITLES.WAYPOINTS": "Waypoints",
    "MAP_VIEW.FORM.SOURCE.LABEL": "Data Source",
    "MAP_VIEW.FORM.SOURCE.PLACEHOLDER": "Select Data Source",
    "MAP_VIEW.LOADING": "Map loading",
    "MAP_VIEW.MODAL_TITLE": "Settings",
    "MAP.HUD.FETCH_BOUNDARIES": "Fetch Boundaries",
    "MAP.HUD.LAT": "Lat:",
    "MAP.HUD.LNG": "Lng:",
    "MAP.HUD.SOURCES": "Sources:",
    "MAP.HUD.TOGGLE_FETCH_BOUNDARY_VISUALIZATION": "Toggle fetch boundary visualization",
    "MAP.HUD.ZOOM_IN_TO_LOAD": "Zoom in to load",
    "MAP.STYLE.SATELLITE": "Satellite view",
    "MAP.STYLE.STREET": "Street view",
    "MEASUREMENT_TYPE.IMPERIAL": "Imperial",
    "MEASUREMENT_TYPE.METRIC": "Metric",
    "MERGE_WAYPOINT.FORM.SUBMIT": "Submit",
    "MERGE_WAYPOINT.FORM.SUCCESS": "Successfully merged waypoints",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL": "Merge selected waypoint into current waypoint",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL_SHORT": "Waypoint",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.PLACEHOLDER": "Select a Waypoint",
    "MERGE_WAYPOINT.INPUT.NOTES.LABEL": "Notes",
    "MERGE_WAYPOINT.INPUT.NOTES.PLACEHOLDER": "Enter Notes",
    "MERGE_WAYPOINT.NO_DATA": "No Waypoints available to merge",
    "METRIC_WIDGET.DESCRIPTION": "per day",
    "METRIC_WIDGET.TITLE_A": "AI Identified",
    "METRIC_WIDGET.TITLE_B": "For Repair",
    "METRIC_WIDGET.TITLE_C": "Delivered",
    "NOT_FOUND_PAGE.ACTION.GO_HOME": "Take Me Home",
    "NOT_FOUND_PAGE.DESCRIPTION": "Oops! The page you're looking for seems to have wandered off into the digital void. Don't worry, it happens to the best of us.",
    "NOT_FOUND_PAGE.TITLE": "Page Not Found",
    "PIE_CHART.SUMMARY_DETAILS": "Summary Details",
    "PIE_CHART.SUMMARY_TOTAL": "Total results",
    "PROCESS_FILES.BUTTON.DISCARD": "Discard",
    "PROCESS_FILES.BUTTON.NEXT": "Next",
    "PROCESS_FILES.BUTTON.PREVIOUS": "Previous",
    "PROCESS_FILES.BUTTON.RESET": "Reset",
    "PROCESS_FILES.COLUMNS_SELECT": "Required columns still to be selected",
    "PROCESS_FILES.COLUMNS_SELECTED": "all columns selected",
    "PROCESS_FILES.DESC.DIAMETER": "Please select either: a unit that matches your diameter values OR a column to map unit values",
    "PROCESS_FILES.ERROR.INSUFFICIENT_COLUMNS": "There are insufficient columns to map to the data provided. To continue please discard or upload a new file.",
    "PROCESS_FILES.ERROR.NO_FILE_TO_MAP": "No file to map for {{type}} please move on by clicking next",
    "PROCESS_FILES.ERROR.SELECT_ALL": "Please select all columns",
    "PROCESS_FILES.FILENAME": "Filename",
    "PROCESS_FILES.INSTRUCTIONS": "Please map the columns to the headers suggested in the dropdowns. Only one column can be mapped to a header.",
    "PROCESS_FILES.MAP_FIELD_TITLE": "Map {{title}} field",
    "PROCESS_FILES.OPTION_COLUMNS_SELECT": "Optional columns still to be selected",
    "PROCESS_FILES.OPTIONAL_COLUMNS_SELECTED": "All optional columns have been selected",
    "PROCESS_FILES.TITLE.DIAMETER": "Map Diameter field",
    "PROFILE_PAGE.BRANCH": "Project:",
    "PROFILE_PAGE.COMPANY": "Company:",
    "PROFILE_PAGE.COMPANY_ADDRESS": "Address:",
    "PROFILE_PAGE.COMPANY_NAME": "Name:",
    "PROFILE_PAGE.DISCARD": "Discard",
    "PROFILE_PAGE.EDIT": "Edit",
    "PROFILE_PAGE.EMAIL": "Email:",
    "PROFILE_PAGE.ERROR.FAILED_LOADING_USER_DATA": "Failed loading user data.",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.BAD_AUTH": "Incorrect Password Entered",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.ERROR": "Current Password Incorrect",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.LOADING": "Loading",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUBMIT": "Submit New Password",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUCCESS": "Success! Your password has been changed.",
    "PROFILE_PAGE.FORM.EMAIL.LABEL": "Email",
    "PROFILE_PAGE.FORM.EMAIL.PLACEHOLDER": "Enter Email",
    "PROFILE_PAGE.FORM.FIRST_NAME.LABEL": "First Name",
    "PROFILE_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Enter First Name",
    "PROFILE_PAGE.FORM.LAST_NAME.LABEL": "Last Name",
    "PROFILE_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Enter Last Name",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.LABEL": "Measurement Type",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.PLACEHOLDER": "Select a measurement type",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.LABEL": "New Password",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.PLACEHOLDER": "Enter New Password",
    "PROFILE_PAGE.FORM.PASSWORD.LABEL": "Password",
    "PROFILE_PAGE.FORM.PASSWORD.PLACEHOLDER": "Enter Password",
    "PROFILE_PAGE.ROLE": "Role:",
    "PROFILE_PAGE.SUBMIT": "Save",
    "PROFILE_PAGE.TABS.ACCOUNT_SETTINGS": "Account Settings",
    "PROFILE_PAGE.TABS.CHANGE_PASSWORD": "Change Password",
    "PROFILE_PAGE.TABS.COMPANY_SETTINGS": "Company Settings",
    "PROFILE_PAGE.TABS.DOCUMENTS": "Documents",
    "PROFILE_PAGE.TITLE": "Edit Profile",
    "PROJECT_ADMIN.TITLE": "Project Admin",
    "PROJECT_CREATE.ERROR.PROJECT_CREATION": "Something went wrong: could not create project",
    "PROJECT_CREATE.FOOTER.CREATE_DRAFT": "Create a draft",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_1": "You can access it in your \"View projects\" section.",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_2": "Before submitting it for approval, please add all the required details.",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECT": "Add details",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECTS": "View projects",
    "PROJECT_CREATE.SUCCESS.TITLE": "A draft project has been created",
    "PROJECT_STATUS.INCOMPLETE_PROJECT_SETUP": "Project setup is incomplete",
    "PROJECT_STATUS.SUMMARY.TITLES.CONFIRMEDLEAKS": "# of Confirmed Leaks",
    "PROJECT_STATUS.SUMMARY.TITLES.LEAKSMARKEDUP": "# of Leaks Marked Up",
    "PROJECT_STATUS.SUMMARY.TITLES.SESSIONS": "# of Sessions",
    "PROJECT_STATUS.SUMMARY.TITLES.WAYPOINTS": "# of Waypoints",
    "PROJECT_STATUS.TITLE": "Project Status",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CANCEL": "Cancel",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CONFIRM": "Confirm delete draft",
    "PROJECT_UPDATE.DELETE_DIALOG.DESCRIPTION": "Are you sure you want to delete this draft?",
    "PROJECT_UPDATE.DELETE_DIALOG.TITLE": "Delete draft",
    "PROJECT_UPDATE.DELETE_DRAFT": "Delete draft",
    "PROJECT_UPDATE.DELETE_PROJECT": "Delete project",
    "PROJECT_UPDATE.ERROR.DELETE_DRAFT": "Something went wrong: could not delete draft",
    "PROJECT_UPDATE.ERROR.PROJECT_DRAFT": "Something went wrong: could not save draft",
    "PROJECT_UPDATE.ERROR.PROJECT_STATUS_UPDATE": "Something went wrong: could not update project status",
    "PROJECT_UPDATE.ERROR.PROJECT_UPDATE": "Something went wrong: could not update project",
    "PROJECT_UPDATE.FOOTER.CONTINUE": "Continue",
    "PROJECT_UPDATE.FOOTER.DONE": "Done",
    "PROJECT_UPDATE.FOOTER.PREVIOUS": "Previous",
    "PROJECT_UPDATE.FOOTER.SAVE_DRAFT": "Save draft",
    "PROJECT_UPDATE.FOOTER.SUBMIT": "Submit",
    "PROJECT_UPDATE.SUCCESS.DRAFT_DELETED": "Draft deleted",
    "PROJECT_UPDATE.SUCCESS.PROJECT_DRAFT": "Project draft saved",
    "PROJECT_UPDATE.SUCCESS.PROJECT_STATUS_UPDATE": "Project status updated",
    "PROJECT_UPDATE.SUCCESS.PROJECT_UPDATE": "Project updated",
    "PROJECT_UPDATE.TITLE_EDIT": "Edit Project",
    "PROJECT_UPDATE.TITLE_VIEW": "View Project",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_GENERAL": "Error loading map",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_NO_GIS": "No GIS found.",
    "PROJECT.FORM.ERROR.ODL_LOADING": "Error loading ODLs",
    "PROJECT.FORM.GIS_DATA.DESCRIPTION": "Upload new GIS data or pick an existing one",
    "PROJECT.FORM.GIS_DATA.EXISTING_GIS_UPLOADS": "Existing GIS uploads",
    "PROJECT.FORM.GIS_DATA.TITLE": "GIS Data",
    "PROJECT.FORM.GIS_DATA.UPLOAD_ALTERNATIVE": "or pick an existing one",
    "PROJECT.FORM.GIS_DATA.UPLOAD_NEW_GIS": "Upload New GIS",
    "PROJECT.FORM.LABEL.COMPANY": "Company",
    "PROJECT.FORM.LABEL.COST_PER_DISTANCE": "Cost per distance ($)",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY": "Deployment Density",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY_LEVEL": "Level {{level}}",
    "PROJECT.FORM.LABEL.DMA": "DMAs",
    "PROJECT.FORM.LABEL.DMAS_LOADING": "DMAs loading...",
    "PROJECT.FORM.LABEL.EMPTY_GIS_PREVIEW ": "No GIS uploaded",
    "PROJECT.FORM.LABEL.END_DATE": "End date",
    "PROJECT.FORM.LABEL.GIS_PREVIEW": "GIS preview",
    "PROJECT.FORM.LABEL.LEAK_RADIUS": "Leak Radius",
    "PROJECT.FORM.LABEL.LEAK_RADIUS_DESCRIPTION": "Adjust the leak radius to control ODL visibility on the map. Changes apply when you release the slider.",
    "PROJECT.FORM.LABEL.ODLS_GENERATING": "Generating ODLs...",
    "PROJECT.FORM.LABEL.PARTNER_OR_SELF_SERVE": "Partner or Self-serve",
    "PROJECT.FORM.LABEL.PROJECT_NAME": "Project name",
    "PROJECT.FORM.LABEL.SELF_SERVE_PROJECT": "Self-serve project",
    "PROJECT.FORM.LABEL.START_DATE": "Start date",
    "PROJECT.FORM.LABEL.TARGET_DISTANCE": "Target distance",
    "PROJECT.FORM.LABEL.TARGET_LEAKAGE": "Target leakage",
    "PROJECT.FORM.LABEL.WAITING_FOR_ODL": "Waiting for ODL generation...",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_1": "Sparse Deployment: Could be a predominantly metallic area or a low budget where you don't need every inch covered,",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_2": "Standard Deployment: This is our standard recommendation for balancing project cost and covering an area that is a mix of metallic and plastic.",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_3": "Complete Coverage: This could be used if you have a very complex plastic network with lots of junctions to ensure complete guaranteed coverage, at a high sensor consumption.",
    "PROJECT.FORM.OPTIONS.NO_MATCHING": "No matching DMAs",
    "PROJECT.FORM.PLACEHOLDER.DMA": "Select DMAs",
    "PROJECT.FORM.PLACEHOLDER.END_DATE": "Pick a date",
    "PROJECT.FORM.PLACEHOLDER.START_DATE": "Pick a date",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.DEFINITELY": "Reject the project definitively",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.WITH_NOTES": "Reject project with notes",
    "PROJECT.REJECT_DIALOG.DEFINITELY.DESCRIPTION": "This action will delete the project.",
    "PROJECT.REJECT_DIALOG.DEFINITELY.TITLE": "Reject the project definitively",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.LABEL": "Notes",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.PLACEHOLDER": "Add your notes",
    "PROJECT.REJECT_DIALOG.OR": "or",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.DESCRIPTION": "The project will be sent back to the user who submitted it. They will be able to edit it and submit it again, or delete it.",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.TITLE": "Reject the project with notes",
    "PROJECT.TOAST.DMA.ERROR": "Error loading DMA data.",
    "PROJECT.TOAST.DMA.LOADING": "Loading DMA data...",
    "PROJECT.TOAST.DMA.SUCCESS": "Successfully loaded DMA data.",
    "PROJECT.TOAST.ODL.ERROR": "Error generating ODLs.",
    "PROJECT.TOAST.ODL.LOADING": "Generating ODLs...",
    "PROJECT.TOAST.ODL.PENDING": "Pending ODL generation...",
    "PROJECT.TOAST.ODL.SUCCESS": "ODLs generated successfully.",
    "PROJECT.VIEW_REJECTION_NOTES.BUTTON_CLOSE": "Got it",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.LABEL.NOTES": "Administrator notes",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.PLACEHOLDER.NOTES": "Notes left by the administrator",
    "PROJECT.VIEW_REJECTION_NOTES.TITLE": "The project has been rejected by an administrator",
    "PROJECTS.LOADING_PROJECT_INFO": "Loading project info...",
    "RECOVERY_EXPIRED_PAGE.SUBTITLE": "Your link is not active anymore",
    "RECOVERY_EXPIRED_PAGE.TITLE": "Password Recovery",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.LABEL": "Email",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Enter your email",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.LABEL": "Password",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.PLACEHOLDER": "Enter your password",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Repeat Password",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Repeat password",
    "RECOVERY_PASSWORD_PAGE.FORM.SUBMIT": "Recover",
    "RECOVERY_PASSWORD_PAGE.SUBTITLE": "Enter your password below",
    "RECOVERY_PASSWORD_PAGE.TITLE": "Password Recovery",
    "REPORT_BUILDER.APPLY": "Apply",
    "REPORT_BUILDER.BACK": "Back",
    "REPORT_BUILDER.EXPORT_TO_PDF": "Export to PDF",
    "REPORT_BUILDER.RUN": "Run",
    "REPORT_BUILDER.SAVE": "Save",
    "REPORT_BUILDER.SORT_MODE": "Sort mode",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.ASSET_LEAK": "Asset Leak",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Client Meter/ PRV Leak",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.COMM_PIPE_LEAK": "Comm Pipe Leak",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_METER_LEAK": "Customer Meter Leak",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Customer Side Leak",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.FERRULE_LEAK": "Ferrule Leak",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.MAINS_LEAK": "Mains Leak",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NA": "N/A",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NETWORK_MAINTENANCE": "Network Maintenance",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RENEW_STOP_TAP_MSM": "Renew Stop Tap/ MSM",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.REPAIR": "Repair",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RESOLVED_ONSITE": "Resolved Onsite",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.ASSET_LEAK": "Asset Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Client Meter/ PRV Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMERCIAL_REPAIR": "Commercial Repair",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMUNICATION_PIPE": "Communication Pipe",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CSL": "CSL",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_METER_LEAK": "Customer Meter Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Customer Side Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.DECOMMISSION_FERRULE": "Decommission Ferrule",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Excavate Trial Hole (Permit)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "External Leaking Meter>40mm Inc Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "External Leaking Meter>40mm No Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "External Leaking Meter<40mm Inc Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "External Leaking Meter<40mm No Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE": "Ferrule",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE_EXCHANGE_NO_5": "Ferrule exchange No.5",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H stopped on site",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_HYDRANT": "Fire Hydrant",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_MAIN": "Fire Main",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Flow Test at Boundary No Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Flow Test at Boundary with Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Inst MSM to Exist Comm Pipe UnMtrd",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_FERRULE_ONLY": "Install Ferrule Only",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_MSM_INC_METER": "Install MSM Inc Meter",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SAMPLE_TAP": "Install Sample Tap",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SLUICE_VALVE": "Install Sluice Valve",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Install Washout Hydrant",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_FIXED_ONSITE": "Leak Fixed Onsite",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_FH": "Leak on F/H",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Leak on spindle of SV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Leak on spindle of SV / flange.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS": "Mains",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_BURST": "Mains burst",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_LEAK": "Mains Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/A - W/O stopped on site",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NETWORK_MAINTENANCE": "Network Maintenance",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OSV_EXCHANGE": "OSV Exchange",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OTHER": "Other",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_FH": "Passing FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_HYDRANT": "Passing Hydrant",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Remedial Work External",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Remove Sluice Vavle",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Renew Communication Pipe Longside",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Renew Communication Pipe Shortside",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COVER_AND_FRAME_STANDARD": "Renew Cover & Frame (Standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FERRULE_ONLY": "Renew Ferrule Only",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT": "Renew Fire Hydrant",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Renew Fire Hydrant Chamber",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_AND_COVER": "Renew Fire Hydrant Frame & Cover",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Renew Leaking Supply Pipe >10m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Renew Leaking Supply Pipe <10m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Renew MSM/Stop Tap Assembly",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_SLUICE_VAVLE": "Renew Sluice Vavle",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Renew Washout Hydrant",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPACK_SLUICE_VALVE": "Repack Sluice Valve",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Repair Communication Pipe",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Repair External LSP - Non Eligible",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Repair Internal Leak (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Repair Leaking Supply Pipe (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LOP": "Repair LOP",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Repair LSP - Eligible",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Repair Main Dowel Piece >=200mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Repair Main Dowel Piece <200mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Repair Main [Not Dowel] >=200mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Repair Main [Not Dowel] <200mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAJOR_BURST": "Repair Major Burst",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Repair Non Return Valve",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Repair Running Overflow (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_SLUICE_VALVE": "Repair Sluice Valve",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Reposition MSM/Stop Tap Assembly",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Reset Surface Box (Standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SERVICE_LEAK": "Service Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE": "Sluice Valve",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE_VL": "Sluice Valve (VL)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_EXCHANGE": "Stop Tap Exchange",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK": "Stop Tap Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK_NO_7": "Stop Tap Leak No.7",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.WO_FH": "WO / FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.LEAK": "Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.NO_LEAK": "No Leak",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE": "Predicted Size",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.LARGE": "Large",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.MEDIUM": "Medium",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.SMALL": "Small",
    "REPORT.FILTERS.DROPDOWN.STATUS": "Status",
    "REPORT.FILTERS.DROPDOWN.STATUS.1": "Breakout",
    "REPORT.FILTERS.DROPDOWN.STATUS.10": "Inprogress ST (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.11": "Known Leak",
    "REPORT.FILTERS.DROPDOWN.STATUS.12": "Leak Submitted To Client",
    "REPORT.FILTERS.DROPDOWN.STATUS.13": "Marked Up",
    "REPORT.FILTERS.DROPDOWN.STATUS.14": "Proposed",
    "REPORT.FILTERS.DROPDOWN.STATUS.15": "Repair Scheduled",
    "REPORT.FILTERS.DROPDOWN.STATUS.16": "Repaired",
    "REPORT.FILTERS.DROPDOWN.STATUS.17": "Scheduled Days",
    "REPORT.FILTERS.DROPDOWN.STATUS.18": "Scheduled Nights",
    "REPORT.FILTERS.DROPDOWN.STATUS.19": "Unconfirmed Noise Source",
    "REPORT.FILTERS.DROPDOWN.STATUS.2": "Confirmed Noise Source",
    "REPORT.FILTERS.DROPDOWN.STATUS.20": "Validated",
    "REPORT.FILTERS.DROPDOWN.STATUS.3": "Data Collection",
    "REPORT.FILTERS.DROPDOWN.STATUS.4": "Deleted",
    "REPORT.FILTERS.DROPDOWN.STATUS.5": "Dry Dig",
    "REPORT.FILTERS.DROPDOWN.STATUS.6": "Edited",
    "REPORT.FILTERS.DROPDOWN.STATUS.7": "Further Work Requested",
    "REPORT.FILTERS.DROPDOWN.STATUS.8": "In Progress",
    "REPORT.FILTERS.DROPDOWN.STATUS.9": "Inprogress LE (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITING_SCHEDULING": "Awaiting Scheduling",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITINGSCHEDULING": "Awaiting Scheduling",
    "REPORT.FILTERS.DROPDOWN.STATUS.CLOSED": "Closed",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMED_NOISE_SOURCE": "Confirmed Noise Source",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMEDNOISESOURCE": "Confirmed Noise Source",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRY_DIG": "Dry Dig",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRYDIG": "Dry Dig",
    "REPORT.FILTERS.DROPDOWN.STATUS.EDITED": "Edited",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHER_WORK_REQUESTED": "Further Work Requested",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHERWORKREQUESTED": "Further Work Requested",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAK_SUBMITTED_TO_CLIENT": "Leak Submitted To Client",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAKSUBMITTEDTOCLIENT": "Leak Submitted To Client",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKED_UP": "Marked Up",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKEDUP": "Marked Up",
    "REPORT.FILTERS.DROPDOWN.STATUS.PROPOSED": "Proposed",
    "REPORT.FILTERS.DROPDOWN.STATUS.REPAIRED": "Repaired",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULED": "Scheduled",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULING": "Scheduling",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED": "Unconfirmed",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED_NOISE_SOURCE": "Unconfirmed Noise Source",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMEDNOISESOURCE": "Unconfirmed Noise Source",
    "REPORT.FILTERS.FILTER.BUTTON": "Filters",
    "REPORT.FILTERS.SAVE.BUTTON": "Save View",
    "REPORTS_PAGE.CREATE_REPORT.BUTTON": "Create Report",
    "REPORTS_PAGE.CREATE_REPORT.FORM.CHOOSE_LAYOUT.LABEL": "Choose Layout",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REDIRECT_TO_EDIT": "Edit report",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.LABEL": "Report Name",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.PLACEHOLDER": "Enter Report Name",
    "REPORTS_PAGE.CREATE_REPORT.FORM.SUBMIT": "Create Report",
    "REPORTS_PAGE.CREATE_REPORT.TITLE": "Create New Report",
    "REPORTS_PAGE.CRUMB": "Reports",
    "REPORTS_PAGE.SUBTITLE": "FIDO Sweep Results Reports",
    "REPORTS_PAGE.TABLE.ACTIONS": "Actions",
    "REPORTS_PAGE.TABLE.CREATED": "Created",
    "REPORTS_PAGE.TABLE.NUMBER": "#",
    "REPORTS_PAGE.TABLE.REPORT_NAME": "Report Name",
    "REPORTS_PAGE.TITLE.NO_REPORTS": "There are no reports",
    "REPORTS_PAGE.TITLE.TOTAL_COUNT": "Total Reports:",
    "REQUEST.FAILED": "Failed",
    "REQUEST.SUCCESS": "Success",
    "SERVER_ERRORS.-1": "Something went wrong",
    "SERVER_ERRORS.1": "Database connection error",
    "SERVER_ERRORS.10": "Empty file error",
    "SERVER_ERRORS.11": "Authentication error",
    "SERVER_ERRORS.12": "Authentication error",
    "SERVER_ERRORS.13": "Authentication error",
    "SERVER_ERRORS.14": "Authentication error",
    "SERVER_ERRORS.15": "Authentication error",
    "SERVER_ERRORS.16": "User with provided email was not found",
    "SERVER_ERRORS.17": "Email or password is incorrect",
    "SERVER_ERRORS.18": "Email token is invalid",
    "SERVER_ERRORS.19": "Permission denied",
    "SERVER_ERRORS.2": "Something went wrong",
    "SERVER_ERRORS.21": "User not found",
    "SERVER_ERRORS.22": "Role not found",
    "SERVER_ERRORS.23": "Company not found",
    "SERVER_ERRORS.24": "Project not found",
    "SERVER_ERRORS.25": "Permission denied",
    "SERVER_ERRORS.26": "Permission denied",
    "SERVER_ERRORS.27": "Invalid file data",
    "SERVER_ERRORS.28": "This email already exists",
    "SERVER_ERRORS.3": "Invalid request",
    "SERVER_ERRORS.31": "Company not found",
    "SERVER_ERRORS.32": "Company name is invalid or already exists",
    "SERVER_ERRORS.4": "Invalid file format",
    "SERVER_ERRORS.41": "Company not found",
    "SERVER_ERRORS.5": "Unauthorized",
    "SERVER_ERRORS.6": "Resource not found",
    "SERVER_ERRORS.61": "Method not allowed",
    "SERVER_ERRORS.62": "API call failed",
    "SERVER_ERRORS.63": "Invalid geometry type",
    "SERVER_ERRORS.65": "Project overlaps with existing projects {{ projectNames }} and DMAs {{ dmaKeys }}",
    "SERVER_ERRORS.7": "Service unavailable",
    "SERVER_ERRORS.8": "Azure storage error",
    "SERVER_ERRORS.9": "Invalid geojson format",
    "SERVER_SUCCESS.ADD_COMPANY": "Company successfully created",
    "SERVER_SUCCESS.CREATE_BRANCH": "Project successfully created",
    "SERVER_SUCCESS.CREATE_USER": "User successfully created",
    "SERVER_SUCCESS.EDIT_COMPANY": "Company successfully updated",
    "SERVER_SUCCESS.EDIT_USER": "User successfully updated",
    "SERVER_SUCCESS.FORGOT_PASSWORD": "Recovery link successfully sent",
    "SERVER_SUCCESS.LOGIN": "Login was successful",
    "SERVER_SUCCESS.LOGOUT": "Logout was successful",
    "SERVER_SUCCESS.RECOVERY": "Recovery was successful",
    "SERVER_SUCCESS.UPDATE_BRANCH": "Project successfully updated",
    "SERVER_SUCCESS.UPDATE_REPORT": "The report was updated",
    "SESSION_PAGE.ENGINEERING_DETAILS.3D_PLOT_TOGGLE_TITLE": "Separate Overnight Sessions",
    "SESSION_PAGE.ENGINEERING_DETAILS.ADDRESS_TITLE": "Address Details",
    "SESSION_PAGE.ENGINEERING_DETAILS.APPLY_DATES": "Apply Dates",
    "SESSION_PAGE.ENGINEERING_DETAILS.ASSET_TITLE": "Asset Images",
    "SESSION_PAGE.ENGINEERING_DETAILS.COLLECTED_ENGINEER": "Collected Engineer",
    "SESSION_PAGE.ENGINEERING_DETAILS.COMPANY": "Company",
    "SESSION_PAGE.ENGINEERING_DETAILS.DATE_TITLE": "Date Times",
    "SESSION_PAGE.ENGINEERING_DETAILS.DEPLOYED_ENGINEER": "Deployed Engineer",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.ADDRESS": "Address",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.COMPANY": "Company",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.CREATED": "Created",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.DMA_KEY": "DMA Key",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.END_TIME": "End Time",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.FIDO_RESULT": "Fido Result",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LAST_UPDATE": "Last Update",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LEAK_SIZE": "Leak Size",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LOCATION": "Location",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SENSOR_ID": "Sensor ID",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_ID": "Session ID",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_STATUS": "Session status",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.START_TIME": "Start Time",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.TYPE": "Type",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.WAYPOINT_NAME": "Waypoint Name",
    "SESSION_PAGE.ENGINEERING_DETAILS.ENGINEER_TITLE": "Engineers",
    "SESSION_PAGE.ENGINEERING_DETAILS.GRAPH_TITLE": "Pollen Graph",
    "SESSION_PAGE.ENGINEERING_DETAILS.ID_TITLE": "List of IDs",
    "SESSION_PAGE.ENGINEERING_DETAILS.LAST_UPDATED": "Days since last update",
    "SESSION_PAGE.ENGINEERING_DETAILS.POSTCODE": "Postcode",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_ERROR": "An error occurred while processing the relay data",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_NO_DATA": "No data currently available",
    "SESSION_PAGE.ENGINEERING_DETAILS.RESET_DATES": "Reset Dates",
    "SESSION_PAGE.ENGINEERING_DETAILS.SESSION_TITLE": "Session Details",
    "SESSION_PAGE.ENGINEERING_DETAILS.TITLE": "FIDO Engineering Details",
    "SESSION_PAGE.ENGINEERING_DETAILS.WHAT3WORDS": "What3Words",
    "SESSION_PAGE.GET_AUDIO.BUTTON.CANCEL": "Cancel Retrieval",
    "SESSION_PAGE.GET_AUDIO.BUTTON.GET": "Retrieve Audio",
    "SESSION_PAGE.GET_AUDIO.BUTTON.NA": "No available relay device",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.CONTENT": "In order to retrieve audio, there must be an attached relay device to this session. If there is no attached relay device then you will not be able to retrieve any audio through the portal for this session and the button will be disabled.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.HEADING": "Availability",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT1": "Regardless of how the relay device was triggered, you can toggle this on or off using the button above. The possible last action and corresponding statuses are",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT2": "Triggered ON by portal user- Relay device will retrieve audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT3": "Triggered OFF by portal user- Relay device will not retrieve audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT4": "Triggered ON by automated process- Relay device will retrieve audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT5": "Triggered OFF by automated process- Relay device will not retrieve audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT6": "N/A- Relay device not available",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.TITLE": "Functionality",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT1": "We will assume that there is an attached relay device for this section.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT2": "You can toggle whether the relay device should attempt to retrieve audio data within the next 24 hours.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT3": "Once a request has been completed, the data on this page will be updated and then the audio retrieval will be switched back off automatically.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT4": "There is also an automated process that will automatically retrieve audio data for all sessions that have a relay device attached, given our model has detected an issue.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.HEADING": "The Process",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.TITLE": "Relay devices explained",
    "SESSION_PAGE.GET_AUDIO.ERROR": "There has been an error, please refresh the page and try again",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION": "Last Action Taken",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_OFF": "Triggered OFF by automated process",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_ON": "Triggered ON by automated process",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.NA": "N/A",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_OFF": "Triggered OFF by portal user",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_ON": "Triggered ON by portal user",
    "SESSION_PAGE.GET_AUDIO.STATUS": "Current Status",
    "SESSION_PAGE.GET_AUDIO.STATUS.GET": "Relay device will retrieve audio",
    "SESSION_PAGE.GET_AUDIO.STATUS.NA": "Relay device not available",
    "SESSION_PAGE.GET_AUDIO.STATUS.NOT_GET": "Relay device will not retrieve audio",
    "SESSION_PAGE.GET_AUDIO.TITLE": "Audio Retrieval",
    "SESSION_PAGE.RELAY_GRAPH.X": "Frequency",
    "SESSION_PAGE.RELAY_GRAPH.Y": "Time",
    "SESSION_PAGE.RELAY_GRAPH.Z": "Power",
    "SESSION_PAGE.SESSION_INFORMATION.FIDO_RESULT": "FIDO Result",
    "SESSION_PAGE.SESSION_INFORMATION.LEAK_SIZE": "Leak Size",
    "SESSION_PAGE.SESSION_INFORMATION.TITLE": "Session Information",
    "SESSION.LOADING_LEAK_MAPPER": "Loading leak mapper...",
    "SESSIONS.STATUS.DELETED": "Deleted",
    "SESSIONS.STATUS.ON_TRACK": "On Track",
    "SESSIONS.STATUS.UPLOADED": "Uploaded",
    "SESSIONS.STATUS.UPLOADING": "Awaiting Upload",
    "SIDEBAR.ADMIN": "Admin",
    "SIDEBAR.BROWSE": "Browse",
    "SIDEBAR.COMPANIES": "Companies",
    "SIDEBAR.COMPANY": "My Company",
    "SIDEBAR.DASHBOARD": "Dashboard",
    "SIDEBAR.DELIVERY_PERFORMANCE": "Delivery Performance",
    "SIDEBAR.DELIVERY_PERFORMANCE_LE": "Leak Engineer",
    "SIDEBAR.DELIVERY_PERFORMANCE_ST": "Sensor Technician",
    "SIDEBAR.DMAPERFORMANCEREPORT": "DMA Performance Report",
    "SIDEBAR.FEEDBACK": "Give feedback",
    "SIDEBAR.GIS": "GIS",
    "SIDEBAR.GIS_ADMIN": "GIS Admin",
    "SIDEBAR.GIS_UPLOAD": "GIS Upload",
    "SIDEBAR.LOGOUT": "Log Out",
    "SIDEBAR.LOGS": "Change logs",
    "SIDEBAR.PROJECT_ADMIN": "Project Admin",
    "SIDEBAR.PROJECT_STATUS": "Project Status",
    "SIDEBAR.PROJECTSTATUS": "Project Status",
    "SIDEBAR.RELAY_MANAGEMENT": "Relay Management",
    "SIDEBAR.REPORTS": "Reports",
    "SIDEBAR.SENSOR_MANAGEMENT": "Sensor Management",
    "SIDEBAR.STOCK_MANAGEMENT": "Stock Management",
    "SIDEBAR.TITLE": "Admin Panel",
    "SIDEBAR.USERS": "User Management",
    "SIDEBAR.VERSION": "Version ",
    "STOCK_MANAGEMENT.DATES_BETWEEN": "Show Usage Between",
    "STOCK_MANAGEMENT.DATES_BETWEEN.AND": "and",
    "STOCK_MANAGEMENT.DISTRIBUTION.CHART_TITLE": "Distribution to Customer",
    "STOCK_MANAGEMENT.DISTRIBUTION.DATE_ERROR": "Start date cannot be greater than end date",
    "STOCK_MANAGEMENT.DISTRIBUTION.FAULTY": "Faulty FIDO Sensors",
    "STOCK_MANAGEMENT.DISTRIBUTION.FILTER": "Filter",
    "STOCK_MANAGEMENT.DISTRIBUTION.NO_DATA": "No stock distribution data for selected date range",
    "STOCK_MANAGEMENT.DISTRIBUTION.REFURBED": "Refurbed FIDO Sensors",
    "STOCK_MANAGEMENT.DISTRIBUTION.RETURNED": "Returned FIDO Sensors",
    "STOCK_MANAGEMENT.DISTRIBUTION.STOCKED": "Stocked FIDO Sensors",
    "STOCK_MANAGEMENT.DISTRIBUTION.TITLE": "Stock Distribution to Customers",
    "STOCK_MANAGEMENT.DISTRIBUTION.TOGGLE_ALL": "Toggle All",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.FAULTY": "Faulty FIDO Relays",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.REFURBED": "Refurbed FIDO Relays",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.RETURNED": "Returned FIDO Relays",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.STOCKED": "Stocked FIDO Relays",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.TITLE": "Relay Distribution to Customers",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.FAULTY": "Faulty FIDO Sensors",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.REFURBED": "Refurbed FIDO Sensors",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.RETURNED": "Returned FIDO Sensors",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.STOCKED": "Stocked FIDO Sensors",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.TITLE": "Sensor Distribution to Customers",
    "STOCK_MANAGEMENT.TABLE.BUG_NAME": "Sensor Name",
    "STOCK_MANAGEMENT.TABLE.BUG_OWNER": "Sensor Owner",
    "STOCK_MANAGEMENT.TABLE.COMMENT": "Comment",
    "STOCK_MANAGEMENT.TABLE.CUSTOMER": "Customer",
    "STOCK_MANAGEMENT.TABLE.DATE": "Latest Date",
    "STOCK_MANAGEMENT.TABLE.DATE_FROM": "From",
    "STOCK_MANAGEMENT.TABLE.DATE_TO": "To",
    "STOCK_MANAGEMENT.TABLE.DEVICE_ID": "Sensor ID",
    "STOCK_MANAGEMENT.TABLE.EDIT_SECTION": "Edit Stock",
    "STOCK_MANAGEMENT.TABLE.EDIT.COMMENTS": "Comments",
    "STOCK_MANAGEMENT.TABLE.EDIT.CUSTOMER": "Customer",
    "STOCK_MANAGEMENT.TABLE.EDIT.DESELECT": "Deselect all stock",
    "STOCK_MANAGEMENT.TABLE.EDIT.DISCARD": "Cancel",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_COMMENTS": "Please enter a comment",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_CUSTOMER": "Please select a customer",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_OWNER": "Please select a sensor owner",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_STATUS": "Please select a status",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_TIMESTAMP": "Please select a timestamp",
    "STOCK_MANAGEMENT.TABLE.EDIT.OWNER": "Sensor Owner",
    "STOCK_MANAGEMENT.TABLE.EDIT.PARTNER": "Partner",
    "STOCK_MANAGEMENT.TABLE.EDIT.RELAY_OWNER": "Relay Owner",
    "STOCK_MANAGEMENT.TABLE.EDIT.SENSOR_OWNER": "Sensor Owner",
    "STOCK_MANAGEMENT.TABLE.EDIT.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.EDIT.SUBMIT": "Update",
    "STOCK_MANAGEMENT.TABLE.EDIT.TIMESTAMP": "Timestamp",
    "STOCK_MANAGEMENT.TABLE.EDIT.TITLE": "Modify Selected Stock",
    "STOCK_MANAGEMENT.TABLE.FILTER": "Filter",
    "STOCK_MANAGEMENT.TABLE.FILTER_SECTION": "Filters, Sorting and Search",
    "STOCK_MANAGEMENT.TABLE.MODIFY": "Modify Selected",
    "STOCK_MANAGEMENT.TABLE.NO_DATA": "No Stock Data",
    "STOCK_MANAGEMENT.TABLE.PERSON": "Person",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_NAME": "Relay Name",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_OWNER": "Relay Owner",
    "STOCK_MANAGEMENT.TABLE.RELAY.COMMENT": "Comment",
    "STOCK_MANAGEMENT.TABLE.RELAY.CUSTOMER": "Customer",
    "STOCK_MANAGEMENT.TABLE.RELAY.DATE": "Latest Date",
    "STOCK_MANAGEMENT.TABLE.RELAY.IMEI": "IMEI",
    "STOCK_MANAGEMENT.TABLE.RELAY.PERSON": "Person",
    "STOCK_MANAGEMENT.TABLE.RELAY.SIM": "SIM ID",
    "STOCK_MANAGEMENT.TABLE.RELAY.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.RELAY.TIMESTAMP": "Latest Time",
    "STOCK_MANAGEMENT.TABLE.SEARCH_BAR.APPLY.FILTER": "Apply filters, sorting and search",
    "STOCK_MANAGEMENT.TABLE.SEARCH.PLACEHOLDER": "Search Sensors...",
    "STOCK_MANAGEMENT.TABLE.SELECT_ALL": "Select All",
    "STOCK_MANAGEMENT.TABLE.SELECT_WAYPOINT": "Select",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_NAME": "Sensor Name",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_OWNER": "Sensor Owner",
    "STOCK_MANAGEMENT.TABLE.SENSOR.COMMENT": "Comment",
    "STOCK_MANAGEMENT.TABLE.SENSOR.CUSTOMER": "Customer",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DATE": "Latest Date",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DEVICE_ID": "Sensor ID",
    "STOCK_MANAGEMENT.TABLE.SENSOR.PERSON": "Person",
    "STOCK_MANAGEMENT.TABLE.SENSOR.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.SENSOR.TIMESTAMP": "Latest Time",
    "STOCK_MANAGEMENT.TABLE.SORT": "Sort",
    "STOCK_MANAGEMENT.TABLE.SORT.ASC": "Ascending",
    "STOCK_MANAGEMENT.TABLE.SORT.DESC": "Descending",
    "STOCK_MANAGEMENT.TABLE.SORT.NONE": "None",
    "STOCK_MANAGEMENT.TABLE.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.STATUSES.customer": "customer",
    "STOCK_MANAGEMENT.TABLE.STATUSES.faulty": "faulty",
    "STOCK_MANAGEMENT.TABLE.STATUSES.new": "new",
    "STOCK_MANAGEMENT.TABLE.STATUSES.refurb": "refurbished",
    "STOCK_MANAGEMENT.TABLE.STATUSES.retired": "retired",
    "STOCK_MANAGEMENT.TABLE.STATUSES.returned": "returned",
    "STOCK_MANAGEMENT.TABLE.STATUSES.stock": "stock",
    "STOCK_MANAGEMENT.TABLE.TIMESTAMP": "Latest Time",
    "STOCK_MANAGEMENT.TABLE.TITLE": "All Stock",
    "SUMMARY.DIALOG.SUBTITLE.CHANGE": "All filters will be deleted?",
    "SUMMARY.DIALOG.SUBTITLE.CLOSE": "Are changes will be deleted",
    "SUMMARY.DIALOG.TITLE.CHANGE": "Are you sure you want to change the Data Source?",
    "SUMMARY.DIALOG.TITLE.CLOSE": "Are you sure you want to close settings?",
    "SUMMARY.FORM.COLUMN.LABEL": "Column",
    "SUMMARY.FORM.COLUMN.PLACEHOLDER": "Select column",
    "SUMMARY.FORM.SOURCE.LABEL": "Data Source",
    "SUMMARY.FORM.SOURCE.PLACEHOLDER": "Select Data Source",
    "SUMMARY.FORM.TITLE.LABEL": "Title",
    "SUMMARY.FORM.TITLE.PLACEHOLDER": "Enter title",
    "SUMMARY.FORM.TYPE.LABEL": "Type",
    "SUMMARY.FORM.TYPE.PLACEHOLDER": "Select type",
    "SUMMARY.MODAL_TITLE": "Settings",
    "SYSTEM_FIELDS.CELLS_FILLED": "Cells filled",
    "SYSTEM_FIELDS.DROPDOWN.1.PLACEHOLDER": "Choose material",
    "SYSTEM_FIELDS.DROPDOWN.2.PLACEHOLDER": "Choose asset type",
    "SYSTEM_FIELDS.DROPDOWN.3.PLACEHOLDER": "Choose pipe type",
    "SYSTEM_FIELDS.DROPDOWN.4.PLACEHOLDER": "Choose status",
    "SYSTEM_FIELDS.DROPDOWN.5.PLACEHOLDER": "Choose units",
    "SYSTEM_FIELDS.ERROR.NUMERIC_UNIQUE_FIELD": "The unique field inputted is numeric and should be a string",
    "SYSTEM_FIELDS.ROW_1": "Row Fields",
    "SYSTEM_FIELDS.ROW_2": "System Fields",
    "SYSTEM_FIELDS.TITLE": "Map cells with system fields",
    "SYSTEM_FIELDS.UNIQUE_VALUES_NOT_FOUND": "No unique values to map",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CHANGE": "All filters will be deleted?",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CLOSE": "Are changes will be deleted",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CHANGE": "Are you sure you want to change the Data Source?",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CLOSE": "Are you sure you want to close settings?",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.LABEL": "Column to show",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.PLACEHOLDER": "Select columns",
    "TABLE_OF_RESULTS.FORM.SOURCE.LABEL": "Data Source",
    "TABLE_OF_RESULTS.FORM.SOURCE.PLACEHOLDER": "Select Data Source",
    "TABLE_OF_RESULTS.MODAL_TITLE": "Settings",
    "TOOLTIP.ADDRESS": "Address",
    "TOOLTIP.ASSET_KEY": "Asset Key",
    "TOOLTIP.COMPANY": "Company",
    "TOOLTIP.CONSUMPTION_PROFILE_ID": "Consumption Profile ID",
    "TOOLTIP.DAYS_SINCE_LAST": "Days since last update",
    "TOOLTIP.DEPLOYED_BY": "Deployed By",
    "TOOLTIP.DEPLOYMENT_ORDER": "Deployment Order",
    "TOOLTIP.DIAMETER": "Diameter",
    "TOOLTIP.DMA_ID": "DMA Id",
    "TOOLTIP.DMA_KEY": "DMA Key",
    "TOOLTIP.DMA_NAME": "DMA Name",
    "TOOLTIP.ENGINEER": "Engineer",
    "TOOLTIP.FIDO_RESULT": "Fido Result",
    "TOOLTIP.LATITUDE": "Latitude",
    "TOOLTIP.LEAK_SIZE": "Leak Size",
    "TOOLTIP.LONGITUDE": "Longitude",
    "TOOLTIP.MATERIAL": "Material",
    "TOOLTIP.PIPE_TYPE": "Pipe Type",
    "TOOLTIP.RECORDINGS_CNT": "Recordings Count",
    "TOOLTIP.SESSION_ID": "Session Id",
    "TOOLTIP.STANDARDISED_MATERIAL": "Standardised Material",
    "TOOLTIP.STANDARISED_ASSET_TYPE": "Standarised Asset Type",
    "TOOLTIP.TOP_SOUND_ID": "Top Sounding ID",
    "TOOLTIP.WAYPOINT_ID": "Waypoint Id",
    "TOOLTIP.WAYPOINT_NAME": "Waypoint Name",
    "TOOLTIP.WHAT_3_WORDS": "What 3 Words",
    "TOP_SOUND_PAGE.AUDIO_INFORMATION": "Audio Information",
    "TOP_SOUND_PAGE.COMPANY": "Company",
    "TOP_SOUND_PAGE.DISTANCE_GRAPH_TITLE": "Distance Graphs",
    "TOP_SOUND_PAGE.ENGINEER": "Engineer",
    "TOP_SOUND_PAGE.HIGH_FREQUENCY": "High Frequency cutoff",
    "TOP_SOUND_PAGE.LOCATION": "Location",
    "TOP_SOUND_PAGE.LOCATION_DETAILS": "Location Details",
    "TOP_SOUND_PAGE.LOW_FREQUENCY": "Low Frequency cutoff",
    "TOP_SOUND_PAGE.NUMBER_PATHS": "Number of paths",
    "TOP_SOUND_PAGE.POSTCODE": "Postcode",
    "TOP_SOUND_PAGE.PSDS_TITLE": "Spectral Profile",
    "TOP_SOUND_PAGE.SPACING": "Spacing",
    "TOP_SOUND_PAGE.STARTING_DISTANCE": "Starting Distance",
    "TOP_SOUND_PAGE.TIME_TOP_SOUNDING": "Time of top sounding",
    "TOP_SOUND_PAGE.TITLE": "Top Sounding",
    "TOP_SOUND_PAGE.WHAT3WORDS": "What3Words",
    "TOP_SOUNDING.GRAPH_ALT": "top sounding distance graph",
    "TOP_SOUNDING.PSD_GRAPH_ALT": "psd graph",
    "UNIT.GALLONS_DAY": "Gallons/day",
    "UNIT.ML_DAY": "ML/Day",
    "UPLOAD_HEALTH_CHECK.BTN": "Upload Health Check",
    "UPLOAD_HEALTH_CHECK.MODAL.BTN.SUBMIT": "Submit",
    "UPLOAD_HEALTH_CHECK.MODAL.DESC": "Please enter the URL in the input below",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.DESC": "Please try again the URL has not been updated",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.TITLE": "Try again!",
    "UPLOAD_HEALTH_CHECK.MODAL.INPUT.LABEL": "Health Check URL",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.DESC": "The health check URL has been updated",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.TITLE": "Awesome!",
    "UPLOAD_HEALTH_CHECK.MODAL.TITLE": "Upload Health Check Report",
    "USER_DETAILS_PAGE.CRUMB": "Manage User",
    "USER_DETAILS_PAGE.DISCARD": "Discard",
    "USER_DETAILS_PAGE.FORM.BRANCH.LABEL": "Project",
    "USER_DETAILS_PAGE.FORM.BRANCH.PLACEHOLDER": "Choose Project",
    "USER_DETAILS_PAGE.FORM.COMPANY.LABEL": "Company",
    "USER_DETAILS_PAGE.FORM.COMPANY.PLACEHOLDER": "Choose Company",
    "USER_DETAILS_PAGE.FORM.EMAIL.LABEL": "Email Address",
    "USER_DETAILS_PAGE.FORM.EMAIL.PLACEHOLDER": "Enter Email",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.LABEL": "First Name",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Enter First Name",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.LABEL": "Last Name",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Enter Last Name",
    "USER_DETAILS_PAGE.FORM.ROLE.LABEL": "Role",
    "USER_DETAILS_PAGE.FORM.ROLE.PLACEHOLDER": "Choose Role",
    "USER_DETAILS_PAGE.SUBMIT": "Save",
    "USER_MANAGEMENT.DROP_DOWN.TITLE": "Groups",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_COMPANY": "Add Company",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PARTNER": "Add Partner",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PROJECT": "Add Project",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_USER": "Add User",
    "USER_MANAGEMENT.ROUTE_TITLES.COMPANY": "Company",
    "USER_MANAGEMENT.ROUTE_TITLES.PARTNER": "Partner",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT": "Project",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT_ARCHIVES": "Archived project",
    "USER_MANAGEMENT.ROUTE_TITLES.RESOURCES": "Resources",
    "USER_MANAGEMENT.ROUTE_TITLES.USER": "User",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_COMPANIES": "View Companies",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_GIS_UPLOADS": "View GIS Uploads",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PARTNERS": "View Partners",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECT_ARCHIVES": "View Archive",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECTS": "View Projects",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_USERS": "View Users",
    "USER_ROLE.COMPANY_ADMIN": "Company Admin",
    "USER_ROLE.COMPANY_BUG_DEPLOYMENT_ENGINEER": "Company Sensor Technician",
    "USER_ROLE.COMPANY_LEAK_ENGINEER": "Company Leak Engineer",
    "USER_ROLE.COMPANY_USER": "Company User",
    "USER_ROLE.PARTNER_ADMIN": "Partner Admin",
    "USER_ROLE.PARTNER_BUG_DEPLOYMENT_ENGINEER": "Partner Sensor Technician",
    "USER_ROLE.PARTNER_LEAK_ENGINEER": "Partner Leak Engineer",
    "USER_ROLE.PARTNER_USER": "Partner User",
    "USER_ROLE.SUPER_ADMIN": "Super Admin",
    "USERS_PAGE.ADD_USER.ACTIONS": "Actions",
    "USERS_PAGE.ADD_USER.BUTTON": "New User",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.LABEL": "Project",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.PLACEHOLDER": "Choose Project",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.LABEL": "Company",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.PLACEHOLDER": "Choose Company",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.LABEL": "Email Address",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.PLACEHOLDER": "Enter Email",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.LABEL": "First Name",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.PLACEHOLDER": "Enter First Name",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.LABEL": "Last Name",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.PLACEHOLDER": "Enter Last Name",
    "USERS_PAGE.ADD_USER.FORM.ROLE.LABEL": "Role",
    "USERS_PAGE.ADD_USER.FORM.ROLE.PLACEHOLDER": "Choose Role",
    "USERS_PAGE.ADD_USER.FORM.SUBMIT": "Add User",
    "USERS_PAGE.ADD_USER.STATUS": "Status",
    "USERS_PAGE.CRUMB": "Users",
    "USERS_PAGE.DELETE_USER.TITLE": "Are you sure you want to delete this User?",
    "USERS_PAGE.SUBTITLE": "Some other Important information goes here",
    "USERS_PAGE.TABLE.ACTIONS": "Actions",
    "USERS_PAGE.TABLE.COMPANY": "Company",
    "USERS_PAGE.TABLE.EMAIL": "Email",
    "USERS_PAGE.TABLE.ID": "ID",
    "USERS_PAGE.TABLE.NAME": "Name",
    "USERS_PAGE.TABLE.ROLE": "Role",
    "USERS_PAGE.TABLE.STATUS": "Status",
    "USERS_PAGE.TITLE.NO_USERS": "There are no users",
    "USERS_PAGE.TITLE.TOTAL_COUNT": "Total Users:",
    "VALIDATION.BRANCHES.UNIQUE": "Project name should be unique",
    "VALIDATION.EMAIL": "Invalid email",
    "VALIDATION.MAX": "Should be less than %1$s characters",
    "VALIDATION.PASSWORD.CONFIRM": "Password and repeat password should be the same",
    "VALIDATION.PASSWORD.LONG": "Password should be less than 128 characters",
    "VALIDATION.PASSWORD.SHORT": "Password should be more than 8 characters",
    "VALIDATION.PASSWORD.SPECIAL": "Password must contain at least one special character",
    "VALIDATION.PHONE": "Phone is invalid",
    "VALIDATION.REQUIRED": "Required",
    "VIEW_COMPANIES.BUTTON.ADD": "Add Company",
    "VIEW_COMPANIES.DELETE_ICON": "Delete icon",
    "VIEW_COMPANIES.EDIT_ICON": "Edit icon",
    "VIEW_COMPANIES.TITLE.ACTION": "Action",
    "VIEW_COMPANIES.TITLE.COMPANY_CODE": "Company Code",
    "VIEW_COMPANIES.TITLE.COUNTRY": "Country Code",
    "VIEW_COMPANIES.TITLE.CURRENCY": "Currency",
    "VIEW_COMPANIES.TITLE.LIST": "List Companies",
    "VIEW_COMPANIES.TITLE.NAME": "Name",
    "VIEW_COMPANIES.TITLE.PAGE": "View Companies",
    "VIEW_COMPANIES.TITLE.PARTNER": "Partner",
    "VIEW_COMPANIES.TITLE.UNIT": "Unit",
    "VIEW_DRAFTS.DIALOG.DELETE.CANCEL": "Disregard",
    "VIEW_DRAFTS.DIALOG.DELETE.CONFIRM": "Delete",
    "VIEW_DRAFTS.DIALOG.DELETE.TITLE": "Are you sure you want to delete this draft?",
    "VIEW_DRAFTS.TITLE.PAGE": "View Drafts",
    "VIEW_PARTNERS.BUTTON.ADD": "Add Partner",
    "VIEW_PARTNERS.TITLE.ACTION": "Action",
    "VIEW_PARTNERS.TITLE.COUNTRY": "Country Code",
    "VIEW_PARTNERS.TITLE.LIST": "List Partners",
    "VIEW_PARTNERS.TITLE.NAME": "Name",
    "VIEW_PARTNERS.TITLE.PAGE": "View Partners",
    "VIEW_PARTNERS.TITLE.PARTNER_CODE": "Partner Code",
    "VIEW_PROJECT_ARCHIVES.DESCRIPTION": "To re-activate a project, please contact support.",
    "VIEW_PROJECTS.ACTION.APPROVE": "Approve",
    "VIEW_PROJECTS.ACTION.ARCHIVE": "Archive",
    "VIEW_PROJECTS.ACTION.DECLINE": "Decline",
    "VIEW_PROJECTS.ACTION.DELETE": "Delete",
    "VIEW_PROJECTS.ACTION.EDIT": "Edit",
    "VIEW_PROJECTS.ACTION.REJECT": "Reject",
    "VIEW_PROJECTS.ACTION.VIEW": "View",
    "VIEW_PROJECTS.ACTION.VIEW_REJECTION_NOTES": "View Rejection Notes",
    "VIEW_PROJECTS.BUTTON.ADD": "Add Project",
    "VIEW_PROJECTS.DIALOG.APPROVE.CANCEL": "Disregard",
    "VIEW_PROJECTS.DIALOG.APPROVE.CONFIRM": "Approve",
    "VIEW_PROJECTS.DIALOG.APPROVE.TITLE": "Are you sure you want to approve this project?",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CANCEL": "Disregard",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CONFIRM": "Confirm",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.DESCRIPTION": "When the project is moved to the archive, the files, waypoints and sessions associated with it will be inactive and not accessible. To re-activate a project, you can open a support ticket.",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.TITLE": "Are you sure you want to archive this project?",
    "VIEW_PROJECTS.DIALOG.DELETE.CANCEL": "Disregard",
    "VIEW_PROJECTS.DIALOG.DELETE.CONFIRM": "Delete",
    "VIEW_PROJECTS.DIALOG.DELETE.TITLE": "Are you sure you want to delete this project?",
    "VIEW_PROJECTS.DIALOG.REJECT.CANCEL": "Disregard",
    "VIEW_PROJECTS.DIALOG.REJECT.CONFIRM": "Reject",
    "VIEW_PROJECTS.DIALOG.REJECT.TITLE": "Are you sure you want to reject this project?",
    "VIEW_PROJECTS.FORM.FILTER.ALL": "All",
    "VIEW_PROJECTS.FORM.FILTER.APPROVED": "Approved",
    "VIEW_PROJECTS.FORM.FILTER.SUBMITTED": "Submitted",
    "VIEW_PROJECTS.NOT_FOUND": "No projects found",
    "VIEW_PROJECTS.TITLE.ACTION": "Action",
    "VIEW_PROJECTS.TITLE.AUTHOR": "Created By",
    "VIEW_PROJECTS.TITLE.COMPANY": "Company",
    "VIEW_PROJECTS.TITLE.DMAS": "View DMAs",
    "VIEW_PROJECTS.TITLE.DMAS_SUBLIST_TITLE": "List of DMAs",
    "VIEW_PROJECTS.TITLE.END_DATE": "End Date",
    "VIEW_PROJECTS.TITLE.LIST": "List Projects",
    "VIEW_PROJECTS.TITLE.NAME": "Name",
    "VIEW_PROJECTS.TITLE.NO_DMAS": "No DMAs",
    "VIEW_PROJECTS.TITLE.PAGE": "View Projects",
    "VIEW_PROJECTS.TITLE.START_DATE": "Start Date",
    "VIEW_PROJECTS.TITLE.STATUS": "Status",
    "VIEW_USERS.ACTION.DELETE": "Delete",
    "VIEW_USERS.ACTION.EDIT": "Edit",
    "VIEW_USERS.ACTION.FORGOT_PASSWORD": "Reset password",
    "VIEW_USERS.BUTTON.ADD": "Add user",
    "VIEW_USERS.BUTTON.INVITE": "Invite user",
    "VIEW_USERS.PAGINATION.TITLE": "Rows per page",
    "VIEW_USERS.ROW.ICON.DELETE.ALT": "Delete icon",
    "VIEW_USERS.ROW.ICON.EDIT.ALT": "Edit icon",
    "VIEW_USERS.TITLE.LIST": "List Users",
    "VIEW_USERS.TITLE.PAGE": "View Users",
    "VIEW_USERS.TITLE.ROW_FIVE": "Action",
    "VIEW_USERS.TITLE.ROW_FOUR": "Role",
    "VIEW_USERS.TITLE.ROW_ONE": "Name",
    "VIEW_USERS.TITLE.ROW_THREE": "Company",
    "VIEW_USERS.TITLE.ROW_TWO": "Partner",
    "WAYPOINT_PAGE.ADD_JOB.ADDRESS": "Address",
    "WAYPOINT_PAGE.ADD_JOB.DATE_EXTERNALLY": "Date Raised Externally",
    "WAYPOINT_PAGE.ADD_JOB.DATE_INTERNALLY": "Date Raised Internally",
    "WAYPOINT_PAGE.ADD_JOB.DESCRIPTION": "Add a job to the waypoint",
    "WAYPOINT_PAGE.ADD_JOB.DISCARD": "Discard",
    "WAYPOINT_PAGE.ADD_JOB.ENGINEERING_NOTE": "Engineering Note",
    "WAYPOINT_PAGE.ADD_JOB.ENVIRONMENTAL_NOTE": "Environmental Note",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.DESC": "Please refresh and try again",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.TITLE": "Something went wrong",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE": "Estimated Leak Size",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE_UNIT": "Leak Size Unit",
    "WAYPOINT_PAGE.ADD_JOB.FLOW_REDUCTION": "Agreed Flow Reduction (m3/hr)",
    "WAYPOINT_PAGE.ADD_JOB.IMAGE_ALT": "Uploaded image {{index}}",
    "WAYPOINT_PAGE.ADD_JOB.IMAGES": "Media",
    "WAYPOINT_PAGE.ADD_JOB.JOB_COMMENT": "Notes",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS": "Job Status",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.CANCELLED": "Cancelled",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG": "Dry Dig",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG_APPEALED": "Dry Dig Appealed",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.NFA": "NFA (No further action)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.PLACEHOLDER": "Select a job status",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_EXTERNALLY": "Raised externally",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_INTERNALLY": "Raised internally",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.REPAIRED": "Repaired",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RFA": "RFA (Request further action)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.VALIDATION": "Please provide a job status",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE": "Job Type",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.ASSET_VALVE_HYDRANT_LEAK": "Asset (Valve/Hydrant) Leak",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Client Meter/PRV Leak",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.COMM_PIPE_LEAK": "Comm Pipe Leak",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_METER_LEAK": "Customer Meter Leak",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Customer Side Leak",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.FERRULE_LEAK": "Ferrule Leak",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.MAINS_LEAK": "Mains Leak",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.NETWORK_MAINTENANCE": "Network Maintenance",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.PLACEHOLDER": "Select a job type",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RENEW_STOP_TAP_MSM": "Renew Stop Tap/MSM",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RESOLVED_ONSITE": "Resolved Onsite",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.VALIDATION": "Please provide a job type",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_ESTIMATE": "Client Leak Size Estimate",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE": "Leak Type",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.ASSET_LEAK": "Asset Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Client Meter/ PRV Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMERCIAL_REPAIR": "Commercial Repair",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMUNICATION_PIPE": "Communication Pipe",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CSL": "CSL",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_METER_LEAK": "Customer Meter Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Customer Side Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.DECOMMISSION_FERRULE": "Decommission Ferrule",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Excavate Trial Hole (Permit)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "External Leaking Meter>40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "External Leaking Meter>40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "External Leaking Meter<40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "External Leaking Meter<40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FERRULE": "Ferrule",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H stopped on site",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_HYDRANT": "Fire Hydrant",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_MAIN": "Fire Main",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Flow Test at Boundary No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Flow Test at Boundary with Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Inst MSM to Exist Comm Pipe UnMtrd",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_FERRULE_ONLY": "Install Ferrule Only",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_MSM_INC_METER": "Install MSM Inc Meter",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SAMPLE_TAP": "Install Sample Tap",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SLUICE_VALVE": "Install Sluice Valve",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Install Washout Hydrant",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_FIXED_ONSITE": "Leak Fixed Onsite",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_FH": "Leak on F/H ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Leak on spindle of SV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Leak on spindle of SV / flange. ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS": "Mains",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_BURST": "Mains burst ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_LEAK": "Mains Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/A - W/O stopped on site ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NETWORK_MAINTENANCE": "Network Maintenance",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NO_LEAK": "No Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OSV_EXCHANGE": "OSV Exchange",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OTHER": "Other",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_FH": "Passing FH",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_HYDRANT": "Passing Hydrant",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PLACEHOLDER": "Select a leak type",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Remedial Work External",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Remove Sluice Vavle",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Renew Communication Pipe Longside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Renew Communication Pipe Shortside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COVER_FRAME_STANDARD": "Renew Cover & Frame (Standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FERRULE_ONLY": "Renew Ferrule Only",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT": "Renew Fire Hydrant",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Renew Fire Hydrant Chamber",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_COVER": "Renew Fire Hydrant Frame & Cover",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Renew Leaking Supply Pipe >10m",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Renew Leaking Supply Pipe <10m ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Renew MSM/Stop Tap Assembly",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_SLUICE_VAVLE": "Renew Sluice Vavle",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Renew Washout Hydrant",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPACK_SLUICE_VALVE": "Repack Sluice Valve",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Repair Communication Pipe",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Repair External LSP - Non Eligible",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Repair Internal Leak (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Repair Leaking Supply Pipe (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LOP": "Repair LOP",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Repair LSP - Eligible",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Repair Main Dowel Piece >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Repair Main Dowel Piece <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Repair Main [Not Dowel] >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Repair Main [Not Dowel] <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAJOR_BURST": "Repair Major Burst",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Repair Non Return Valve",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Repair Running Overflow (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_SLUICE_VALVE": "Repair Sluice Valve",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Reposition MSM/Stop Tap Assembly",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Reset Surface Box (Standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SERVICE_LEAK": "Service Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE": "Sluice Valve",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE_VL": "Sluice Valve (VL)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_EXCHANGE": "Stop Tap Exchange",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK": "Stop Tap Leak",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK_NO_7_FERRULE_EXCHANGE_NO_5": "Stop Tap Leak No.7\n\nFerrule exchange No.5",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.VALIDATION": "Please provide a leak type",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.WO_FH": "WO / FH",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER": "Pipe Diameter",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER_UNIT": "Diameter Unit",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_MATERIAL": "Pipe Material",
    "WAYPOINT_PAGE.ADD_JOB.REMOVE_IMAGE_ARIA": "Remove image {{index}}",
    "WAYPOINT_PAGE.ADD_JOB.REPAIR_DATE": "Repair Date",
    "WAYPOINT_PAGE.ADD_JOB.ROAD_SPEED": "Road Speed",
    "WAYPOINT_PAGE.ADD_JOB.SELECT_UNIT.PLACEHOLDER": "Select unit",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT": "Add New Job",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT.VALIDATION": "Validation failed, please check inputs.",
    "WAYPOINT_PAGE.ADD_JOB.SUCCESS": "Successfully added job",
    "WAYPOINT_PAGE.ADD_JOB.SURFACE_TYPE": "Surface Type",
    "WAYPOINT_PAGE.ADD_JOB.TITLE": "Add Job",
    "WAYPOINT_PAGE.ADD_JOB.W3W": "What3Words",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER": "Client/Utility's Work Order Reference",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER.VALIDATION": "Please provide a client/utility's work order reference",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.ACTION": "Action",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.DATE": "Date",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.address": "Address",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.agreed_flow_reduction": "Flow Reduction",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.comment": "Comment",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_externally": "Date Raised Externally",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_internally": "Date Raised Internally",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.environmental_notes": "Environmental Notes",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.estimate_leak_size": "Estimated Leak Size",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.id": "ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_status": "Job Status",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_type": "Job Type",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.leak_type_id": "Leak Type ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.material": "Material",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.pipe_diameter": "Pipe Diameter",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.repair_date": "Repair Date",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.road_speed": "Road Speed",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.surface_type": "Surface Type",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.urls": "URLs",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.w3w": "W3W",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.waypoint_id": "Waypoint ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.work_order": "Client/Utility's Work Order Reference",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NEW": "New Value",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NOTES": "Additional Notes",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.OLD": "Previous Value",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.STATUS": "Status",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.TITLE": "Job Logs",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.USER": "User",
    "WAYPOINT_PAGE.JOB_TABLE.CREATED_DATE": "Created date",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_ERROR": "Start date must be before end date",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE": "Date Type",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE.PLACEHOLDER": "Select date type",
    "WAYPOINT_PAGE.JOB_TABLE.END_DATE": "End date",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Asset (Valve/Hydrant) Leak": "Asset (Valve/Hydrant) Leak",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Cancelled": "Cancelled",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Client Meter/PRV Leak": "Client Meter/PRV Leak",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Comm Pipe Leak": "Comm Pipe Leak",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Customer Meter Leak": "Customer Meter Leak",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Ferrule Leak": "Ferrule Leak",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Leak Repair": "Leak Repair",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Mains Leak": "Mains Leak",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised externally": "Raised externally",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised internally": "Raised internally",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Repaired": "Repaired",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Scheduled": "Scheduled",
    "WAYPOINT_PAGE.JOB_TABLE.FILTERS": "Filters, Sorting and Search",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.CREATED": "Created Date",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.FLOW_REDUCTION": "Agreed Flow Reduction",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_COMMENTS": "Notes",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_STATUS": "Job Status",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_TYPE": "Job Type",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_SIZE": "Leak Size",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_TYPE": "Leak Type",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.REPAIR_DATE": "Repair Date",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.UPDATED_DATE": "Updated Date",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.WORK_ORDER": "Client/Utility's Work Order Reference",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA": "No matching jobs",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA_EXISTS": "No jobs exist for this waypoint",
    "WAYPOINT_PAGE.JOB_TABLE.REPAIR_DATE": "Repair date",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.BUTTON": "Apply filters, sorting and search",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.PLACEHOLDER": "Search Jobs...",
    "WAYPOINT_PAGE.JOB_TABLE.START_DATE": "Start date",
    "WAYPOINT_PAGE.JOB_TABLE.TITLE": "Jobs for Waypoint",
    "WAYPOINT_PAGE.JOB_TABLE.UPDATED_DATE": "Updated date",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ACTUAL_LEAK_TYPE": "Actual Leak Type",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADD_JOB": "Add Job",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADDRESS": "Address",
    "WAYPOINT_PAGE.WAYPOINT_INFO.AI_PREDICTED_LEAK_SIZE": "AI predicted leak size",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ASSIGNED_ENGINEER": "Assigned Engineer",
    "WAYPOINT_PAGE.WAYPOINT_INFO.BTN_MERGE": "Merge Waypoint",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CANCEL": "Cancel",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CNS": "CNS",
    "WAYPOINT_PAGE.WAYPOINT_INFO.COMMENT": "Engineering Note",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CURRENT_STATUS": "Status",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER": "Diameter",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER_UNIT": "Diameter Unit",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_NAME": "DMA name",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_REFERENCE": "DMA Reference",
    "WAYPOINT_PAGE.WAYPOINT_INFO.EDIT_FIELDS": "Edit Fields",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ENVIRONMENTAL_NOTES": "Environmental Notes",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE": "Agreed Flow Reduction",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT": "Client Leak Size Estimate",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT_UNIT": "Client Leak Size Estimate Unit",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER": "On-Site Leak Size Estimate",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER_UNIT": "On-Site Leak Size Estimate Unit",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_UNIT": "Agreed Flow Reduction Unit",
    "WAYPOINT_PAGE.WAYPOINT_INFO.JOB_TYPE_CODE": "Job Code",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_SCHEDULED_ENGINEER": "Assigned Engineer",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_UPDATE": "Days since last update",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LEAK_TYPE": "Leak Type",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PIPE_MATERIAL": "Pipe Material",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.DATE": "Select Date",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.ENGINEER": "Assign Engineer",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.JOB_TYPE_CODE": "Select Job Code",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.LEAK_TYPE": "Select Leak Type",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.MATERIAL": "Pipe Material",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.STATUS": "Select status",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_LEAK_SIZE": "On-Site Leak Type Estimate",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_SIZE": "Predicted size",
    "WAYPOINT_PAGE.WAYPOINT_INFO.REPAIR_TIME": "Dig Date",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SUBMIT": "Save",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SURFACE_TYPE": "Surface type",
    "WAYPOINT_PAGE.WAYPOINT_INFO.TITLE": "Waypoint Information",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WAYPOINT_NAME": "Waypoint name",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT_3_WORDS": "What 3 Words",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT3WORDS": "What3Words",
    "WAYPOINT_SIZE_WIDGET.DAY": "Day",
    "WAYPOINT_SIZE_WIDGET.DAY_other": "Days",
    "WAYPOINT_SIZE_WIDGET.NO_NAME": "None",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_A": "Latest Leak",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_B": "Longest Leak",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_C": "Largest Leak",
    "WAYPOINT_SIZE_WIDGET.TITLE": "Waypoints",
    "WIDGET_LAYOUT.CANCEL_TEXT": "No",
    "WIDGET_LAYOUT.CONFIRM_TEXT": "Yes",
    "WIDGET_LAYOUT.FILTERS": "Filters",
    "WIDGET_LAYOUT.MAP_VIEW": "Map View",
    "WIDGET_LAYOUT.REMOVE_WIDGET": "Remove Widget",
    "WIDGET_LAYOUT.SETTINGS": "Settings",
    "WIDGET_LAYOUT.SUBTITLE": "All settings will be deleted",
    "WIDGET_LAYOUT.SUMMARY": "Summary",
    "WIDGET_LAYOUT.TABLE_OF_RESULTS": "Table of Results",
    "WIDGET_LAYOUT.TITLE": "Are you sure you want to delete this widget?"
  }
}
